"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[486],{

/***/ 98640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ ButtonIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21483);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25989);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyleIconButton = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].button */ .Z.button([
  ({ theme, loading, color, activeColor, size, backgroundColor, isMobile }) => `
  all: unset;
  color: ${loading ? theme.colors[activeColor] || activeColor : theme.colors[color] || color};
  position: relative;
  cursor: pointer;
  width: ${size}px;
  height: ${size}px;
  padding: 5px;
  border-radius: 9999px;
  box-sizing: content-box;
  text-align: center;
  display:inline-flex;
  box-shadow: 1px ${theme.colors[backgroundColor] || backgroundColor};
  outline: none;
  &:focus,&:active,&:hover {
    border: none!important;
    outline: none!important;
    box-shadow: none !important;
  };

  ${!isMobile && `&:hover,&:active {
      background-color: ${theme.colors.background};
      color: ${theme.colors[activeColor] || activeColor};
    };`}
  ${loading ? `
    background-color: ${theme.colors.background} !important;
    &::after {
      content:"";
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left:0;
      margin: auto;
      animation: spinner 1s linear infinite;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      box-shadow: 0 1px 0 0 ${theme.colors[activeColor] || activeColor};
      box-sizing: content-box;
    };` : ""}

  @keyframes spinner {
    0% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(180deg);
    }
    100% {
      transform: rotate(360deg);
    }
  };`,
  _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F
]);
const ButtonIcon = (_a) => {
  var _b = _a, {
    children
  } = _b, props = __objRest(_b, [
    "children"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyleIconButton, __spreadValues({}, props), (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(children, __spreadProps(__spreadValues({}, children.props), {
    size: props.size,
    color: "currentColor"
  })));
};
ButtonIcon.defaultProps = {
  activeColor: "primary",
  color: "textSecondary"
};




/***/ }),

/***/ 63512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25989);
/* harmony import */ var _Grid_constant_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62122);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21483);
/* harmony import */ var _helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96098);






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div`
  padding-right: 16px;
  padding-left: 16px;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  @media (min-width: ${_Grid_constant_es_js__WEBPACK_IMPORTED_MODULE_2__/* .BREAK_POINTS.xl */ .d.xl}) {
    width: ${(props) => props.fluid ? "100%" : (0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__/* .pixelParse */ .oJ)(props.maxWidth || "")};
  }
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_4__/* .CommonStyles */ .F}
`;
const Container = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => {
  const _a = props, { children, fluid = false, maxWidth = 1232 } = _a, others = __objRest(_a, ["children", "fluid", "maxWidth"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({
    maxWidth,
    fluid,
    ref
  }, others), children);
});
Container.displayName = "Container";




/***/ }),

/***/ 93005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ Divider; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _teko_types_shared__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84019);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25989);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21483);
/* harmony import */ var _helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96098);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Divider = (_a) => {
  var _b = _a, {
    width = "100%",
    height = "1px",
    color = "black",
    dividerStyle = _teko_types_shared__WEBPACK_IMPORTED_MODULE_1__/* .DividerStyleEnum.solid */ .fd.solid,
    align,
    gap,
    alignContent,
    spacingContent,
    children
  } = _b, rest = __objRest(_b, [
    "width",
    "height",
    "color",
    "dividerStyle",
    "align",
    "gap",
    "alignContent",
    "spacingContent",
    "children"
  ]);
  const renderSeparator = () => {
    if (!children) {
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(WrapperSeparator, {
        width,
        weight: height,
        dividerStyle,
        color,
        align
      });
    }
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(WrapperSeparatorText, {
      width,
      weight: height,
      dividerStyle,
      color,
      align,
      alignContent,
      spacingContent
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, children));
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(WrapperDivider, __spreadProps(__spreadValues({}, rest), {
    gap
  }), renderSeparator());
};
const WrapperDivider = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(({ gap }) => [
  _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .CommonStyles */ .F,
  `
  --divider-gap: ${(0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_4__/* .pixelParse */ .oJ)(gap != null ? gap : "") || "12px"};
  display: flex;
  padding-top: var(--divider-gap);
  padding-bottom: var(--divider-gap);
`
]);
const transformAlign = (align) => {
  switch (align) {
    case _teko_types_shared__WEBPACK_IMPORTED_MODULE_1__/* .Alignment.center */ .v2.center:
      return "margin: 0 auto;";
    case _teko_types_shared__WEBPACK_IMPORTED_MODULE_1__/* .Alignment.right */ .v2.right:
      return `
        margin: 0 auto;
        margin-right: 0;
      `;
    default:
      return "";
  }
};
const transformAlignContent = (alignContent) => {
  const css = `{
    display: block;
    content: "";
    border-bottom: 0;
    flex-grow: 1;
    border-top: var(--divider-border-width) var(--divider-border-style) var(--divider-color);
  }`;
  switch (alignContent) {
    case _teko_types_shared__WEBPACK_IMPORTED_MODULE_1__/* .Alignment.left */ .v2.left:
      return `
          &:after ${css}
        `;
    case _teko_types_shared__WEBPACK_IMPORTED_MODULE_1__/* .Alignment.right */ .v2.right:
      return `
          &:before ${css}
        `;
    default:
      return `
          &:after, &:before ${css}
        `;
  }
};
const WrapperSeparator = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(({
  width,
  weight,
  dividerStyle,
  color,
  align,
  theme
}) => `
  --divider-border-style: ${dividerStyle};
  --divider-color: ${color ? (theme == null ? void 0 : theme.colors[color]) || color : theme == null ? void 0 : theme.colors.divider};
  --divider-border-width: ${weight || "1px"};
  display: flex;
  width: ${width ? width : "100%"};
  border-top: var(--divider-border-width) var(--divider-border-style) var(--divider-color);
  ${transformAlign(align || _teko_types_shared__WEBPACK_IMPORTED_MODULE_1__/* .Alignment.left */ .v2.left)}
`);
const WrapperSeparatorText = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(({
  width,
  weight,
  dividerStyle,
  color = "black",
  align,
  alignContent,
  spacingContent,
  theme
}) => `
  --divider-border-style: ${dividerStyle};
  --divider-color: ${(theme == null ? void 0 : theme.colors[color]) || color};
  --divider-border-width: ${weight || "1px"};
  --divider-content-spacing: ${spacingContent || "10px"};
  display: flex;
  align-items: center;
  width: ${width ? width : "100%"};
  ${transformAlign(align || _teko_types_shared__WEBPACK_IMPORTED_MODULE_1__/* .Alignment.left */ .v2.left)}
  ${transformAlignContent(alignContent || _teko_types_shared__WEBPACK_IMPORTED_MODULE_1__/* .Alignment.center */ .v2.center)}

  > span {
    margin: 0 var(--divider-content-spacing);
    margin-left: ${alignContent === "left" ? "0" : "var(--divider-content-spacing)"};
    margin-right: ${alignContent === "right" ? "0" : "var(--divider-content-spacing)"};
  }
`);
Divider.displayName = "Divider";




/***/ }),

/***/ 36344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ Flex; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21483);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25989);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledFlex = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div((_a) => {
  var _b = _a, { theme } = _b, props = __objRest(_b, ["theme"]);
  return [
    (0,_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F)(__spreadValues({ theme }, props)),
    {
      display: "flex",
      flexDirection: props.direction,
      gap: theme.spacing[props.gap || "s0"],
      columnGap: theme.spacing[props.gapX || props.gap || "s0"],
      rowGap: theme.spacing[props.gapY || props.gap || "s0"],
      justifyContent: buildVariant(props.justify || ""),
      alignItems: buildVariant(props.align || ""),
      flexWrap: props.flexWrap
    }
  ];
});
const buildVariant = (variant) => {
  switch (variant) {
    case "start":
      return "flex-start";
    case "end":
      return "flex-end";
    default:
      return variant;
  }
};
StyledFlex.defaultProps = {
  direction: "row",
  justify: "start",
  align: "baseline",
  flexWrap: "nowrap"
};
const Flex = (props) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledFlex, __spreadValues({}, props));




/***/ }),

/***/ 6836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ InputNumber; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var rc_input_number__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41305);
/* harmony import */ var _Typography_index_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71323);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90333);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34059);
/* harmony import */ var _Shape_index_es_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(88123);
/* harmony import */ var _constants_index_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1902);
/* harmony import */ var _contexts_SizeContext_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34363);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21483);









var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SAVED_DECIMAL_SEPARATOR = ".";
const InputNumber = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_a, ref) => {
  var _b = _a, {
    size: customizeSize,
    addonBefore,
    addonAfter,
    bordered = true,
    disabled = false,
    readOnly = false
  } = _b, props = __objRest(_b, [
    "size",
    "addonBefore",
    "addonAfter",
    "bordered",
    "disabled",
    "readOnly"
  ]);
  var _a2, _b2;
  const size = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_contexts_SizeContext_es_js__WEBPACK_IMPORTED_MODULE_3__/* .SizeContext */ .X);
  const mergeSize = customizeSize || size || "m";
  const { decimalSeparator } = props;
  const formatter = (value) => {
    if (!value)
      return "";
    if (typeof value === "string") {
      value = parseFloat(value);
    }
    const locale = decimalSeparator === "." ? "en-CA" : "de-DE";
    return new Intl.NumberFormat(locale, {
      maximumFractionDigits: 10
    }).format(value);
  };
  const parser = (value) => {
    if (!value) {
      return "";
    }
    const thousandSeparator = decimalSeparator === "." ? "," : ".";
    return value.replace(thousandSeparator, "").replace(decimalSeparator || ".", SAVED_DECIMAL_SEPARATOR);
  };
  const prefix = addonBefore ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledSpace, {
    height: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_4__/* .MAPPING_SIZE */ .v[mergeSize]
  }, typeof addonBefore === "string" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_5__/* .Body */ .uT, {
    color: "textSecondary",
    level: 1,
    weight: "regular"
  }, addonBefore) : react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(addonBefore, {
    size: ((_a2 = addonBefore == null ? void 0 : addonBefore.props) == null ? void 0 : _a2.size) || 20
  })) : null;
  const suffix = addonAfter ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledSpace, {
    height: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_4__/* .MAPPING_SIZE */ .v[mergeSize],
    marginLeft: "s16"
  }, typeof addonAfter === "string" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_5__/* .Body */ .uT, {
    color: "textSecondary",
    level: 1,
    weight: "regular"
  }, addonAfter) : react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(addonAfter, {
    size: ((_b2 = addonAfter == null ? void 0 : addonAfter.props) == null ? void 0 : _b2.size) || 20
  })) : null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    height: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_4__/* .MAPPING_SIZE */ .v[mergeSize],
    disabled,
    readOnly,
    bordered,
    paddingRight: !!suffix ? "s16" : "s0",
    className: "wrap-input-number"
  }, prefix, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(rc_input_number__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, __spreadValues({
    ref,
    upHandler: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__/* .UpOutlined */ .X, {
      size: 12
    }),
    downHandler: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_7__/* .DownOutlined */ .T, {
      size: 12
    }),
    disabled,
    readOnly,
    formatter,
    parser
  }, props)), suffix);
});
InputNumber.displayName = "InputNumber";
const Wrapper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_Shape_index_es_js__WEBPACK_IMPORTED_MODULE_8__/* .Shape */ .b)(({ theme, disabled, readOnly, bordered }) => `
  ${disabled ? `background: ${theme == null ? void 0 : theme.colors.background}; 
         cursor: not-allowed;` : "background: white;"}
  ${bordered ? `border: 1px solid ${theme == null ? void 0 : theme.colors.border};
         border-radius: 4px;` : ""}
  &:focus-within{
    border-color: ${theme == null ? void 0 : theme.colors.link500};
  }
  display: flex;
  padding-left: 0.75rem;
  .rc-input-number {
      position: relative;
      flex: 1;
      padding: 0 1px;
      &:hover{
        .rc-input-number-handler-wrap{
            opacity: 1;
        }
      }
  }
  .rc-input-number-input-wrap{
      height: 100%;
      & input {
        width: 100%;
        height: 100%;
        outline: 0;
        border: 0;
        &::placeholder {
          color: ${theme == null ? void 0 : theme.colors.placeholder};
        }
        ${disabled ? "cursor: not-allowed;" : ""}
    }
  }
  .rc-input-number-handler-wrap{
      opacity: 0;
      transition: opacity 0.24s linear 0.1s;
      position: absolute;
      display: flex;
      flex-direction: column;
      justify-content: center;
      right: 0;
      line-height: 0;
      height: 100%;
      width: 25px;
      ${bordered ? `border-left: 1px solid ${theme == null ? void 0 : theme.colors.border};
             border-right: 1px solid ${theme == null ? void 0 : theme.colors.border};` : ""}
      ${disabled || readOnly ? "display: none;" : ""}
  }
  .rc-input-number-handler-up, 
  .rc-input-number-handler-down{
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    &:hover path {
      stroke: ${theme == null ? void 0 : theme.colors.link500};
    }
  }
  .rc-input-number-handler-down {
    ${bordered ? `border-top: 1px solid ${theme == null ? void 0 : theme.colors.border};` : ""}
  }
  .rc-input-number-handler-up-disabled, 
  .rc-input-number-handler-down-disabled {
    cursor: not-allowed;
    background: ${theme == null ? void 0 : theme.colors.background};
    &:hover path {
      stroke: ${theme == null ? void 0 : theme.colors.textSecondary};
    }
  }
`);
const StyledSpace = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_Shape_index_es_js__WEBPACK_IMPORTED_MODULE_8__/* .Shape */ .b)`
  display: flex;
  align-items: center;
`;




/***/ }),

/***/ 60049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ ModalBody; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25989);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21483);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(`
  flex: 1 1 auto;
  padding: 0.5rem 2rem;
  position: relative;
`, _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F);
const ModalBody = (_a) => {
  var _b = _a, {
    children
  } = _b, props = __objRest(_b, [
    "children"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, props), children);
};




/***/ }),

/***/ 47873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ ModalHeader; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21483);



const ModalHeader = ({
  children,
  className
}) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
  className
}, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Title, null, children));
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div`
  padding: 1rem;
  text-align: center;
`;
const Title = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h5 */ .Z.h5`
  margin-bottom: 0;
  color: ${(p) => p.theme.colors.textTitle};
`;




/***/ }),

/***/ 57572:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ Tooltip; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var react_popper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81668);
/* harmony import */ var _Typography_index_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71323);
/* harmony import */ var _style_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40138);
/* harmony import */ var _utils_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(633);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Tooltip = (_a) => {
  var _b = _a, {
    children,
    placement = "auto",
    title,
    triggerHover = true,
    show,
    backgroundColor,
    textColor,
    style,
    timeDelay = 500
  } = _b, rest = __objRest(_b, [
    "children",
    "placement",
    "title",
    "triggerHover",
    "show",
    "backgroundColor",
    "textColor",
    "style",
    "timeDelay"
  ]);
  const elementRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const tooltipRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const arrowRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const [visible, setVisible] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const timerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const { styles, attributes } = (0,react_popper__WEBPACK_IMPORTED_MODULE_1__/* .usePopper */ .D)(elementRef.current, tooltipRef.current, {
    placement,
    modifiers: [
      {
        name: "arrow",
        options: { element: arrowRef.current }
      },
      {
        name: "offset",
        options: {
          offset: [0, 8]
        }
      }
    ]
  });
  const actionHover = triggerHover ? {
    onMouseEnter: () => timerRef.current = setTimeout(() => setVisible(true), timeDelay),
    onMouseLeave: () => {
      timerRef.current && clearTimeout(timerRef.current);
      setVisible(false);
    }
  } : {};
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!triggerHover) {
      setVisible(!!show);
    }
  }, [show]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", __spreadValues({}, actionHover), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    style: { display: "flex" },
    ref: elementRef
  }, children), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_style_es_js__WEBPACK_IMPORTED_MODULE_2__/* .TooltipWrapper */ .pf, __spreadValues(__spreadValues({
    ref: tooltipRef,
    style: __spreadValues(__spreadProps(__spreadValues({}, styles.popper), {
      visibility: visible ? "visible" : "hidden",
      zIndex: 999
    }), style),
    backgroundColor
  }, attributes.popper), rest), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_style_es_js__WEBPACK_IMPORTED_MODULE_2__/* .StyledArrow */ .bC, {
    ref: arrowRef,
    style: __spreadValues({}, styles.arrow),
    backgroundColor,
    className: (0,_utils_es_js__WEBPACK_IMPORTED_MODULE_3__/* .getArrowClassName */ .C)(attributes) || "",
    "data-placement": placement
  }), typeof title === "string" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_4__/* .Body */ .uT, {
    level: 1,
    weight: "regular",
    color: textColor || "white"
  }, title) : react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(title, {
    style: __spreadValues({ color: textColor || "white" }, title == null ? void 0 : title.props)
  })));
};




/***/ }),

/***/ 38149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Quantity; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _constants_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1902);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69433);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72852);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25989);
/* harmony import */ var _InputNumber_InputNumber_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6836);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21483);







var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const QuantitySize = {
  xs: {
    height: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CORE_SIZE.s28 */ .y.s28,
    width: "5.75rem"
  },
  s: {
    height: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CORE_SIZE.s32 */ .y.s32,
    width: "6.375rem"
  },
  m: {
    height: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CORE_SIZE.s40 */ .y.s40,
    width: "6.375rem"
  }
};
const QuantityWrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div((props) => {
  var _a, _b, _c, _d, _e, _f;
  return [
    _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .CommonStyles */ .F,
    `
  height: ${QuantitySize[props.size || "m"].height};
  width: ${props.block ? "100%" : QuantitySize[props.size || "m"].width};
  border-radius: ${(_a = props.theme) == null ? void 0 : _a.borderRadius.s};
  background: ${props.disabled ? (_b = props.theme) == null ? void 0 : _b.colors.background : (_c = props.theme) == null ? void 0 : _c.colors.tableHeader};
  ${!props.disabled ? `border: ${(_d = props.theme) == null ? void 0 : _d.borderWeight.m} solid ${((_e = props.theme) == null ? void 0 : _e.colors[props.color]) || ((_f = props.theme) == null ? void 0 : _f.colors.divider)};` : ""}
  display: flex;
  align-items: center;
  overflow: hidden;
`
  ];
});
const Plus = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].button */ .Z.button(({ disabled }) => `
    height: 100%;
    width: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    user-select: none;
    border: none;
    background: transparent;
    &:focus {
      outline: none;
    }
    ${disabled ? "cursor: not-allowed;" : ""}
`);
const Minus = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].button */ .Z.button(({ disabled }) => `
    height: 100%;
    width: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    user-select: none;
    border: none;
    background: transparent;
    &:focus {
      outline: none;
    }
    ${disabled ? "cursor: not-allowed;" : ""}
`);
const InputWrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(({ color, theme }) => `
  flex: 1;
  .wrap-input-number {
    padding: 0;
    border: none;
    background-color: transparent;
  }
  .wrap-input-number input {
    text-align: center;
    background-color: transparent;
    font-size: 0.8125rem;
    font-weight: 500;
    color: ${color ? (theme == null ? void 0 : theme.colors[color]) || color : "rgb(67, 70, 87)"};
  }
`);
const IconButonWapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span */ .Z.span`
  display: inline-flex;
  align-items: center;
`;
const Quantity = (_a) => {
  var _b = _a, {
    min = 1,
    max = 999,
    quantity = 1,
    precision,
    decimalSeparator = ",",
    step = 1,
    size = "s",
    disabled,
    disableInput,
    disableMinus,
    disablePlus,
    className,
    onMinus,
    onPlus,
    setQuantity,
    color,
    block,
    blurOnEnter = false
  } = _b, rest = __objRest(_b, [
    "min",
    "max",
    "quantity",
    "precision",
    "decimalSeparator",
    "step",
    "size",
    "disabled",
    "disableInput",
    "disableMinus",
    "disablePlus",
    "className",
    "onMinus",
    "onPlus",
    "setQuantity",
    "color",
    "block",
    "blurOnEnter"
  ]);
  const inputRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const onChange = (val) => {
    if (typeof val === "string") {
      val = parseFloat(val);
    }
    if (typeof val !== "number") {
      return;
    }
    setQuantity == null ? void 0 : setQuantity(val);
  };
  const onDecrease = () => {
    if (onMinus) {
      onMinus();
    } else if (step) {
      setQuantity == null ? void 0 : setQuantity(quantity - step);
    }
  };
  const onIncrease = () => {
    if (onPlus) {
      onPlus();
    } else if (step) {
      setQuantity == null ? void 0 : setQuantity(quantity + step);
    }
  };
  const disableMinusButton = disabled || disableMinus || quantity - step < min;
  const disablePlusButton = disabled || disablePlus || quantity + step > max;
  const disableInputField = disabled || disableInput;
  const handleBlurOnEnter = (e) => {
    var _a2;
    const ENTER_CHAR_CODE = 13;
    if (e.charCode === ENTER_CHAR_CODE) {
      (_a2 = inputRef.current) == null ? void 0 : _a2.blur();
    }
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const current = inputRef.current;
    if (blurOnEnter) {
      current == null ? void 0 : current.addEventListener("keypress", handleBlurOnEnter);
    }
    return () => {
      current == null ? void 0 : current.removeEventListener("keypress", handleBlurOnEnter);
    };
  }, [blurOnEnter]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(QuantityWrapper, __spreadValues({
    className,
    size,
    block,
    disabled,
    color,
    onClick: (e) => e.preventDefault()
  }, rest), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Minus, {
    disabled: disableMinusButton,
    onClick: onDecrease,
    color
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconButonWapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__/* .MinusOutlined */ .l, {
    color: disableMinusButton ? "disable" : color || "textPrimary",
    size: 16
  }))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(InputWrapper, {
    color
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_InputNumber_InputNumber_es_js__WEBPACK_IMPORTED_MODULE_5__/* .InputNumber */ .R, {
    ref: inputRef,
    value: quantity,
    onFocus: (event) => event.target.select(),
    onChange,
    disabled: disableInputField,
    controls: false,
    min,
    max,
    step,
    precision,
    decimalSeparator
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Plus, {
    disabled: disablePlusButton,
    onClick: onIncrease,
    color
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconButonWapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__/* .AddOutlined */ .v, {
    color: disablePlusButton ? "disable" : color || "textPrimary",
    size: 16
  }))));
};




/***/ }),

/***/ 72852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ AddOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32600);


const AddOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.75 4C12.75 3.58579 12.4142 3.25 12 3.25C11.5858 3.25 11.25 3.58579 11.25 4V11.25H4C3.58579 11.25 3.25 11.5858 3.25 12C3.25 12.4142 3.58579 12.75 4 12.75H11.25V20C11.25 20.4142 11.5858 20.75 12 20.75C12.4142 20.75 12.75 20.4142 12.75 20V12.75H20C20.4142 12.75 20.75 12.4142 20.75 12C20.75 11.5858 20.4142 11.25 20 11.25H12.75V4Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 30221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ ChecklistOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32600);


const ChecklistOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.88334 3.75C7.88334 3.33579 8.21913 3 8.63334 3H15.4289C15.8431 3 16.1789 3.33579 16.1789 3.75V3.97071H17.3118C18.8306 3.97071 20.0618 5.20193 20.0618 6.72071V18.2533C20.0618 19.7721 18.8306 21.0033 17.3118 21.0033H6.75C5.23122 21.0033 4 19.7721 4 18.2533V6.72071C4 5.20193 5.23122 3.97071 6.75 3.97071H7.88334V3.75ZM16.1789 7.63315V5.47071H17.3118C18.0022 5.47071 18.5618 6.03036 18.5618 6.72071V18.2533C18.5618 18.9437 18.0022 19.5033 17.3118 19.5033H6.75C6.05964 19.5033 5.5 18.9437 5.5 18.2533V6.72071C5.5 6.03036 6.05964 5.47071 6.75 5.47071H7.88334V7.63315C7.88334 8.04736 8.21913 8.38315 8.63334 8.38315H10.3322C10.7464 8.38315 11.0822 8.04736 11.0822 7.63315C11.0822 7.42585 11.3581 7.00247 12.0311 7.00247C12.7041 7.00247 12.98 7.42585 12.98 7.63315C12.98 8.04736 13.3158 8.38315 13.73 8.38315H15.4289C15.8431 8.38315 16.1789 8.04736 16.1789 7.63315ZM9.38334 4.5V6.88315H9.73243C10.0999 6.01694 11.0835 5.50247 12.0311 5.50247C12.9787 5.50247 13.9623 6.01694 14.3298 6.88315H14.6789V4.5H9.38334ZM15.6523 12.0465C15.9452 11.7536 15.9452 11.2788 15.6523 10.9859C15.3594 10.693 14.8845 10.693 14.5916 10.9859L11.3282 14.2493L10.1341 13.0552C9.84125 12.7623 9.36638 12.7623 9.07348 13.0552C8.78059 13.3481 8.78059 13.8229 9.07348 14.1158L10.7979 15.8403C10.9386 15.9809 11.1293 16.0599 11.3282 16.0599C11.5271 16.0599 11.7179 15.9809 11.8586 15.8403L15.6523 12.0465Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 34059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ DownOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32600);


const DownOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M5 8.5L12 15.5L19 8.5",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 48673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ MenuOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32600);


const MenuOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 512 512" },
    child: [
      { tag: "title", attr: {}, child: [] },
      {
        tag: "line",
        attr: {
          x1: "88",
          y1: "152",
          x2: "424",
          y2: "152",
          fill: "none",
          stroke: "#000",
          strokeLinecap: "round",
          strokeMiterlimit: "10",
          strokeWidth: "48px"
        }
      },
      {
        tag: "line",
        attr: {
          x1: "88",
          y1: "256",
          x2: "424",
          y2: "256",
          fill: "none",
          stroke: "#000",
          strokeLinecap: "round",
          strokeMiterlimit: "10",
          strokeWidth: "48px"
        }
      },
      {
        tag: "line",
        attr: {
          x1: "88",
          y1: "360",
          x2: "424",
          y2: "360",
          fill: "none",
          stroke: "#000",
          strokeLinecap: "round",
          strokeMiterlimit: "10",
          strokeWidth: "48px"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 69433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ MinusOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32600);


const MinusOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.25 12C3.25 11.5858 3.58579 11.25 4 11.25H20C20.4142 11.25 20.75 11.5858 20.75 12C20.75 12.4142 20.4142 12.75 20 12.75H4C3.58579 12.75 3.25 12.4142 3.25 12Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 93692:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ PromoOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32600);


const PromoOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.19499 3C5.99608 3 5.80532 3.07902 5.66466 3.21967L3.21967 5.66466C3.07902 5.80532 3 5.99608 3 6.19499V11.085C3 11.2839 3.07902 11.4747 3.21967 11.6153L12.3884 20.784C12.6813 21.0769 13.1562 21.0769 13.4491 20.784L17.1166 17.1166L20.784 13.4491C21.0769 13.1562 21.0769 12.6813 20.784 12.3884L11.6153 3.21967C11.4747 3.07902 11.2839 3 11.085 3H6.19499ZM4.5 6.50565L6.50565 4.5H10.7743L19.1931 12.9187L16.0559 16.0559L12.9187 19.1931L4.5 10.7743V6.50565ZM7.86186 9.2514C7.86186 8.65286 8.34707 8.16765 8.94561 8.16765C9.54415 8.16765 10.0294 8.65286 10.0294 9.2514C10.0294 9.84994 9.54415 10.3351 8.94561 10.3351C8.34707 10.3351 7.86186 9.84994 7.86186 9.2514ZM8.94561 6.66765C7.51865 6.66765 6.36186 7.82444 6.36186 9.2514C6.36186 10.6784 7.51865 11.8351 8.94561 11.8351C10.3726 11.8351 11.5294 10.6784 11.5294 9.2514C11.5294 7.82444 10.3726 6.66765 8.94561 6.66765ZM11.3097 12.9996C11.0168 12.7067 10.5419 12.7067 10.249 12.9996C9.95613 13.2925 9.95613 13.7674 10.249 14.0603L12.3884 16.1996C12.6813 16.4925 13.1562 16.4925 13.449 16.1996C13.7419 15.9067 13.7419 15.4319 13.449 15.139L11.3097 12.9996ZM12.694 10.5545C12.9869 10.2616 13.4618 10.2616 13.7547 10.5545L15.8941 12.6939C16.187 12.9868 16.187 13.4616 15.8941 13.7545C15.6012 14.0474 15.1263 14.0474 14.8334 13.7545L12.694 11.6151C12.4011 11.3223 12.4011 10.8474 12.694 10.5545Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 14214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ ShoppingCartOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32600);


const ShoppingCartOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3 3.75C3 3.33579 3.33579 3 3.75 3H6.00033C6.41455 3 6.75033 3.33579 6.75033 3.75V6.00035H18.7522C18.9832 6.00035 19.2012 6.10676 19.3434 6.28879C19.4855 6.47083 19.5358 6.7082 19.4798 6.93225L17.9796 12.9331C17.8961 13.267 17.5961 13.5012 17.252 13.5012H6.75033V14.2516C6.75033 14.4505 6.82937 14.6413 6.97007 14.782C7.11076 14.9227 7.30158 15.0018 7.50055 15.0018H19.5023C19.9165 15.0018 20.2523 15.3376 20.2523 15.7518C20.2523 16.166 19.9165 16.5018 19.5023 16.5018H7.50055C6.90376 16.5018 6.33141 16.2647 5.90941 15.8427C5.48741 15.4207 5.25033 14.8483 5.25033 14.2516V12.7544C5.25033 12.7534 5.25033 12.7523 5.25033 12.7512C5.25033 12.7502 5.25033 12.7491 5.25033 12.748V6.75355C5.25033 6.75249 5.25033 6.75142 5.25033 6.75035C5.25033 6.74929 5.25033 6.74822 5.25033 6.74715V4.5H3.75C3.33579 4.5 3 4.16421 3 3.75ZM6.75033 7.50035V12.0012H16.6664L17.7916 7.50035H6.75033ZM6.0006 19.5024C6.0006 18.6739 6.67222 18.0023 7.50071 18.0023C8.3292 18.0023 9.00082 18.6739 9.00082 19.5024C9.00082 20.3309 8.3292 21.0025 7.50071 21.0025C6.67222 21.0025 6.0006 20.3309 6.0006 19.5024ZM18.0021 18.0023C17.1736 18.0023 16.502 18.6739 16.502 19.5024C16.502 20.3309 17.1736 21.0025 18.0021 21.0025C18.8306 21.0025 19.5022 20.3309 19.5022 19.5024C19.5022 18.6739 18.8306 18.0023 18.0021 18.0023Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 90333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ UpOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32600);


const UpOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M19 15.5L12 8.5L5 15.5",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 21850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ CartNumberTracking; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);


const CartNumberTracking = ({
  totalItems
}) => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "shoppingCartProductNumber",
    style: { display: "none" }
  }, totalItems);
};




/***/ }),

/***/ 96494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ CustomLink; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35874);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86029);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Anchor = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.a */ .z.a`
  color: unset;
  text-decoration: unset;
`;
const CustomLink = (_a) => {
  var _b = _a, {
    targetPath,
    children,
    targetType = "_self",
    passHref = false
  } = _b, props = __objRest(_b, [
    "targetPath",
    "children",
    "targetType",
    "passHref"
  ]);
  if (!targetPath)
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children);
  const a11yProps = {};
  if (typeof children !== "string") {
    a11yProps["aria-label"] = "Image";
  }
  if (targetPath.startsWith("http") || targetPath.startsWith("/"))
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Anchor, __spreadValues(__spreadValues({
      target: targetType,
      href: targetPath
    }, a11yProps), props), children);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
    href: passHref ? targetPath : `/search?${targetPath}`,
    prefetch: false,
    legacyBehavior: true
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Anchor, __spreadValues(__spreadValues({
    target: targetType,
    href: passHref ? targetPath : `/search?${targetPath}`
  }, a11yProps), props), children));
};




/***/ }),

/***/ 74497:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ ListTile; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86029);



var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div((props) => `
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: ${props.selected ? "#f5f5f5" : "#fff"};
    padding: 0.6rem;
    cursor: ${props.onClick ? "pointer" : ""};
    &:hover {
      background-color: ${props.type !== "search-suggestion" && "#f5f5f5"};
    }
  `);
const Title = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${(props) => props.numberOfLine};
  overflow: hidden;
  margin: 0 0.6rem;
  flex: 1;
`;
const ListTile = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_a, ref) => {
  var _b = _a, {
    leading,
    title,
    trailing,
    numberOfLine = 1,
    onClick,
    onMouseEnter,
    type,
    selected = false
  } = _b, props = __objRest(_b, [
    "leading",
    "title",
    "trailing",
    "numberOfLine",
    "onClick",
    "onMouseEnter",
    "type",
    "selected"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadProps(__spreadValues({
    ref,
    selected,
    onMouseEnter
  }, props), {
    onClick,
    type
  }), leading, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Title, {
    numberOfLine
  }, title), trailing);
});
ListTile.displayName = "ListTile";




/***/ }),

/***/ 21627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* binding */ Messenger; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/libs/styled.es.js
var styled_es = __webpack_require__(86029);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-48286aefe3/1/packages/ecommerce/dist/assets/images/live-chat-full.es.js
var messengerFull = "https://shopfront-cdn.tekoapis.com/static/3ad4c9a97ab98ff3.png";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-48286aefe3/1/packages/ecommerce/dist/assets/images/live-chat.es.js
var messenger = "https://shopfront-cdn.tekoapis.com/static/a8e347d31db4d701.png";



// EXTERNAL MODULE: ../../packages/tracking/dist/helper.es.js
var helper_es = __webpack_require__(28247);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-48286aefe3/1/packages/ecommerce/dist/Common/Messenger/Messenger.es.js






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const Wrapper = styled_es/* styled.a */.z.a`
  z-index: 1030;
  position: fixed;
  right: 2.5rem;
  bottom: 5.6rem;
  cursor: pointer;
  @media (min-width: 1440px) {
    .fb-chat-full {
      display: block;
    }
    .fb-chat {
      display: none;
    }
  }
  @media (max-width: 1440px) {
    .fb-chat-full {
      display: none;
    }
    .fb-chat {
      display: block;
    }
  }
  @media print {
    display: none;
  }
`;
const Messenger = ({
  url
}) => {
  return /* @__PURE__ */ react.createElement(Wrapper, __spreadValues({
    href: url,
    target: "_blank",
    rel: "noreferrer"
  }, (0,helper_es/* getTrackingData */.O)({
    isTrackContent: true,
    regionName: "quickAction",
    contentName: "fbMessengerIcon"
  })), /* @__PURE__ */ react.createElement("img", {
    className: "fb-chat-full",
    src: messengerFull,
    alt: "fb-chat"
  }), /* @__PURE__ */ react.createElement("img", {
    className: "fb-chat",
    src: messenger,
    alt: "fb-chat"
  }));
};




/***/ }),

/***/ 32777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ Footer; }
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-48286aefe3/1/packages/ecommerce/dist/i18n.es.js
var i18n_es = __webpack_require__(33627);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/libs/styled.es.js
var styled_es = __webpack_require__(86029);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/Container/Container.es.js
var Container_es = __webpack_require__(81142);
// EXTERNAL MODULE: ../../.yarn/__virtual__/reflexbox-virtual-125c14c7ff/0/cache/reflexbox-npm-4.0.6-201af1058c-b532551c8b.zip/node_modules/reflexbox/dist/index.js
var dist = __webpack_require__(81026);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/Button/Button.es.js
var Button_es = __webpack_require__(5510);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-48286aefe3/1/packages/ecommerce/dist/Layout/Footer/components/FooterBlock/FooterBlock.es.js



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const ColumnTitle = styled_es/* styled.div */.z.div`
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 10px;
`;
const StyledButton = (0,styled_es/* styled */.z)(Button_es/* Button */.z)((props) => `
  font-size: 12px;
  color: #333;
  padding-left: 0px;
  text-align: left;
  text-decoration: none;
  padding-bottom: 0px;
  max-width: ${!props.block ? "72px" : "initial"};
  justify-content: flex-start;
`);
const ContactInnerLine = styled_es/* styled.div */.z.div`
  font-size: 12px;
  width: 100%;
  a {
    text-decoration: none;
  }
  span {
    line-height: 1.5rem;
  }
  padding-top: 0.365rem;
  padding-right: 0.75rem;
`;
const StyledImg = styled_es/* styled.img */.z.img((props) => `
  ${props.isLogo ? "max-width: 180px;" : ""}
  width: 100%;
`);
const FooterBlock = ({
  title,
  links = [],
  emails = [],
  phones = [],
  flexDir = "row",
  image,
  isLogoImage,
  btnBlock = true
}) => {
  return /* @__PURE__ */ react.createElement(react.Fragment, null, title && /* @__PURE__ */ react.createElement(ColumnTitle, {
    key: title
  }, title), emails.map((email, index) => {
    return /* @__PURE__ */ react.createElement(ContactInnerLine, {
      key: `email-${index}`,
      dangerouslySetInnerHTML: {
        __html: `${email.children} <a href='mailto:${email.address}'>${email.address}</a>`
      }
    });
  }), phones.map((phone, index) => {
    return /* @__PURE__ */ react.createElement(ContactInnerLine, {
      key: `phone-${index}`,
      dangerouslySetInnerHTML: {
        __html: `${phone.children} <a href='tel:${phone.number.replace(/\./g, "")}'}>${phone.number}</a>`
      }
    });
  }), links.map((link, index) => {
    return /* @__PURE__ */ react.createElement(StyledButton, __spreadValues({
      tag: "a",
      block: btnBlock,
      link: true,
      key: `link-${index}`,
      flexDirection: flexDir
    }, link));
  }), image && /* @__PURE__ */ react.createElement(StyledImg, {
    isLogo: !!isLogoImage,
    src: image,
    alt: ""
  }));
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-48286aefe3/1/packages/ecommerce/dist/Layout/Footer/Footer.es.js






const FooterWrapper = styled_es/* styled.div */.z.div(({ theme }) => `
  @media print {
    display: none;
  }
  border-top: solid 3px ${theme == null ? void 0 : theme.brand.primary};
  position: relative;
`);
const Wrapper = styled_es/* styled.nav */.z.nav(({ theme }) => `
  background-color: ${theme == null ? void 0 : theme.colors.white};
  padding: 1rem 0;
`);
const StyledContainer = (0,styled_es/* styled */.z)(Container_es/* Container */.W)`
  display: flex;
  margin-bottom: 10px;
`;
const ColumnInnerLine = styled_es/* styled.div */.z.div`
  font-size: 12px;
  width: 100%;
  padding-right: 8px;
  a {
    color: #333;
    text-decoration: none;
    display: flex;
    align-items: center;
  }
  span {
    line-height: 1.5rem;
  }
`;
const StyledWrapper = (0,styled_es/* styled */.z)(Wrapper)(({ customBottomColor, theme }) => `
  background-color: ${customBottomColor && (theme == null ? void 0 : theme.colors[customBottomColor]) || "#e9edf2"};
  margin-top: -10px;
  padding-top: 30px;
  padding-bottom: 25px;
`);
const CompanyName = styled_es/* styled.div */.z.div`
  font-size: 14px;
  text-transform: uppercase;
  font-weight: bold;
  margin-bottom: 15px;
`;
const BranchName = styled_es/* styled.span */.z.span`
  font-size: 12px;
  font-weight: bold;
`;
const Footer_es_StyledImg = styled_es/* styled.img */.z.img`
  width: 100%;
  max-width: 160px;
`;
const StyledLink = styled_es/* styled.a */.z.a`
  display: block;
  &:not(:first-child) {
    margin-top: 0.5rem;
  }
`;
const StyledDMCA = styled_es/* styled.div */.z.div`
  margin-top: 0.5rem;
  img {
    width: 100%;
    max-width: 100px;
  }
`;
const Description = styled_es/* styled.p */.z.p`
  font-size: 0.75rem;
  text-align: center;
  margin: 0;
`;
const getResponsiveWidth = (col) => {
  switch (col) {
    case 2:
      return [1 / 2, 1 / 2, 1 / 2, 1 / 2];
    case 3:
      return [1 / 2, 1 / 2, 1 / 2, 1 / 3];
    case 4:
      return [1 / 2, 1 / 2, 1 / 2, 1 / 4];
    default:
      return [1 / 2, 1 / 3, 1 / 3, 1 / 5];
  }
};
const Footer = ({
  footer,
  customBottomColor,
  baseUrl
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o;
  return /* @__PURE__ */ react.createElement(FooterWrapper, null, (footer.bankList || footer.supportAndPolicy || footer.paymentMethods) && /* @__PURE__ */ react.createElement(Wrapper, null, footer.supportAndPolicy && /* @__PURE__ */ react.createElement(StyledContainer, null, /* @__PURE__ */ react.createElement(dist/* Flex */.kC, {
    flexWrap: "wrap",
    justifyContent: "space-between",
    width: "100%"
  }, footer.supportAndPolicy.map((column, index) => {
    return /* @__PURE__ */ react.createElement(dist/* Box */.xu, {
      width: !!footer.supportAndPolicy ? getResponsiveWidth(footer.supportAndPolicy.length) : void 0,
      key: index
    }, /* @__PURE__ */ react.createElement(FooterBlock, {
      title: column.title,
      links: column.links,
      emails: column.emails,
      phones: column.phones,
      image: column.image,
      isLogoImage: true
    }));
  }))), /* @__PURE__ */ react.createElement(StyledContainer, null, /* @__PURE__ */ react.createElement(dist/* Flex */.kC, {
    flexWrap: "wrap"
  }, footer.paymentMethods && /* @__PURE__ */ react.createElement(dist/* Box */.xu, {
    width: [1, 1, "40%"]
  }, /* @__PURE__ */ react.createElement(FooterBlock, {
    title: footer.paymentMethods.title,
    links: footer.paymentMethods.links,
    flexDir: "column",
    btnBlock: false
  })), footer.bankList && /* @__PURE__ */ react.createElement(dist/* Box */.xu, {
    width: [1, 1, "60%"]
  }, /* @__PURE__ */ react.createElement(FooterBlock, {
    title: (0,i18n_es.t)("Danh s\xE1ch c\xE1c ng\xE2n h\xE0ng thanh to\xE1n online"),
    image: footer.bankList.imgSrc
  }))))), footer.bottom && /* @__PURE__ */ react.createElement(StyledWrapper, {
    customBottomColor
  }, /* @__PURE__ */ react.createElement(StyledContainer, null, /* @__PURE__ */ react.createElement(dist/* Flex */.kC, {
    flexWrap: "wrap",
    width: "100%"
  }, /* @__PURE__ */ react.createElement(dist/* Box */.xu, {
    width: [1, "50%", "35%", "40%"]
  }, ((_a = footer.bottom) == null ? void 0 : _a.company) && /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(CompanyName, null, (_b = footer.bottom) == null ? void 0 : _b.company.name), /* @__PURE__ */ react.createElement(ColumnInnerLine, {
    dangerouslySetInnerHTML: {
      __html: (_c = footer.bottom) == null ? void 0 : _c.company.detail
    }
  }))), /* @__PURE__ */ react.createElement(dist/* Box */.xu, {
    width: [1, "50%", "35%", "40%"]
  }, footer.bottom.address && footer.bottom.address.map((addressDetail) => {
    return /* @__PURE__ */ react.createElement("div", {
      key: addressDetail.branchName
    }, /* @__PURE__ */ react.createElement(BranchName, null, addressDetail.branchName), ":", /* @__PURE__ */ react.createElement(ColumnInnerLine, null, addressDetail.branchAddress));
  }), footer.bottom.phone && footer.bottom.email && /* @__PURE__ */ react.createElement(ColumnInnerLine, null, `${(0,i18n_es.t)("S\u1ED1 \u0111i\u1EC7n tho\u1EA1i")}: ${footer.bottom.phone} - Email: ${footer.bottom.email} `)), /* @__PURE__ */ react.createElement(dist/* Box */.xu, {
    width: [1, "100%", "30%", "20%"]
  }, !!((_e = (_d = footer == null ? void 0 : footer.bottom) == null ? void 0 : _d.registeredLogo) == null ? void 0 : _e.logo) && /* @__PURE__ */ react.createElement(StyledLink, {
    href: (_f = footer.bottom.registeredLogo) == null ? void 0 : _f.link,
    rel: "noreferrer noopener",
    target: "_blank"
  }, /* @__PURE__ */ react.createElement(Footer_es_StyledImg, {
    src: footer.bottom.registeredLogo.logo,
    alt: "registered logo"
  })), !!((_h = (_g = footer == null ? void 0 : footer.bottom) == null ? void 0 : _g.verifiedLogo) == null ? void 0 : _h.logo) && /* @__PURE__ */ react.createElement(StyledLink, {
    href: (_i = footer.bottom.verifiedLogo) == null ? void 0 : _i.link,
    rel: "noreferrer noopener",
    target: "_blank"
  }, /* @__PURE__ */ react.createElement(Footer_es_StyledImg, {
    src: footer.bottom.verifiedLogo.logo,
    alt: "verified logo"
  })), ((_j = footer == null ? void 0 : footer.bottom) == null ? void 0 : _j.dmcaBadgeLink) && ((_k = footer == null ? void 0 : footer.bottom) == null ? void 0 : _k.dmcaId) && /* @__PURE__ */ react.createElement(StyledDMCA, null, /* @__PURE__ */ react.createElement("a", {
    href: `//www.dmca.com/Protection/Status.aspx?ID=${(_l = footer == null ? void 0 : footer.bottom) == null ? void 0 : _l.dmcaId}&refurl=${baseUrl}`,
    title: "DMCA.com Protection Status",
    className: "dmca-badge"
  }, /* @__PURE__ */ react.createElement("img", {
    src: `${(_m = footer == null ? void 0 : footer.bottom) == null ? void 0 : _m.dmcaBadgeLink}?ID=${(_n = footer == null ? void 0 : footer.bottom) == null ? void 0 : _n.dmcaId}`,
    alt: "DMCA.com Protection Status"
  })))), /* @__PURE__ */ react.createElement(dist/* Box */.xu, {
    width: [1]
  }, ((_o = footer == null ? void 0 : footer.bottom) == null ? void 0 : _o.description) && /* @__PURE__ */ react.createElement(Description, {
    dangerouslySetInnerHTML: {
      __html: footer.bottom.description
    }
  }))))));
};




/***/ }),

/***/ 33627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ NAMESPACE; },
/* harmony export */   "t": function() { return /* binding */ t; }
/* harmony export */ });
/* harmony import */ var i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96556);


var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const NAMESPACE = "ecommerce";
const t = (keys, options) => {
  const text = i18next__WEBPACK_IMPORTED_MODULE_0__/* ["default"].t */ .Z.t(keys, __spreadProps(__spreadValues({}, options), {
    ns: NAMESPACE,
    interpolation: { escapeValue: false }
  }));
  return text || keys;
};




/***/ }),

/***/ 47364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ Text; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79690);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86029);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const getColor = (props) => {
  const { color, theme } = props;
  return color && ((theme == null ? void 0 : theme.brand[color]) || (theme == null ? void 0 : theme.colors[color])) || color || (theme == null ? void 0 : theme.colors.dark) || "";
};
const StyledText = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div(styled_system__WEBPACK_IMPORTED_MODULE_1__.space, (props) => {
  return `
    color: ${getColor(props)};
    font-weight: ${props.fontWeight || "400"};
    font-size: ${props.fontSize || 14}px;
    ${props.lineHeight ? ` line-height: ${props.lineHeight}px;` : ""}
    text-align: ${props.textAlign || "left"};
    overflow: hidden;
    ${props.maxLines ? `text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: ${props.maxLines};` : ""}
    ${props.textTransform ? `
      text-transform: ${props.textTransform};
    ` : ""}
  `;
});
const Text = (props) => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledText, __spreadProps(__spreadValues({}, props), {
    maxLines: props.maxLines || 0
  }));
};




/***/ }),

/***/ 34567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ EnhancedImage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8081);
/* harmony import */ var _TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92651);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const EnhancedImage = (props) => {
  const _a = props, { link, tracking } = _a, rest = __objRest(_a, ["link", "tracking"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_1__/* .TekoLink */ .A, __spreadValues({}, link), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .E, __spreadValues(__spreadValues({}, rest), !!tracking ? { tracking } : {})));
};




/***/ }),

/***/ 19298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ MegaMenu; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71323);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21483);
/* harmony import */ var _MenuPanel_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74010);
/* harmony import */ var _TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92651);
/* harmony import */ var _EnhancedImage_EnhancedImage_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34567);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const MegaMenu = ({
  type,
  align = "left",
  menuItems
}) => {
  const [activeMenu, setActiveMenu] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(void 0);
  const verticalMenuWidth = "12.375rem";
  const horizontalMenuHeight = "3rem";
  const megaMenuHeight = "28.5rem";
  if (!menuItems.length)
    return null;
  const hideMenuPanel = () => {
    setActiveMenu(void 0);
  };
  const renderVerticalMegaMenu = () => {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MegaMenuWrapper, {
      onMouseLeave: hideMenuPanel
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(VerticalMegaMenu, {
      className: activeMenu ? "active" : "",
      width: verticalMenuWidth,
      height: megaMenuHeight
    }, menuItems.slice(0, 14).map((item, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_1__/* .TekoLink */ .A, __spreadProps(__spreadValues({}, item.link), {
      key: index
    }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(VerticalMenuItem, {
      onMouseEnter: () => {
        setActiveMenu(item);
      }
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(VerticalMenuItemImageMegaMenuWrapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_EnhancedImage_EnhancedImage_es_js__WEBPACK_IMPORTED_MODULE_2__/* .EnhancedImage */ .N, {
      src: item.icon,
      height: "100%"
    })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Caption */ .YS, {
      level: 2,
      line: 1,
      style: { flex: 1 }
    }, item.name))))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(VerticalMenuPanel, {
      className: activeMenu ? "active" : "",
      type,
      verticalMenuWidth,
      menu: activeMenu,
      onClickMenuItem: hideMenuPanel
    }));
  };
  const renderHorizontalMegaMenu = () => {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MegaMenuWrapper, {
      onMouseLeave: hideMenuPanel
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(HorizontalMegaMenu, {
      height: horizontalMenuHeight,
      align
    }, menuItems.slice(0, 14).map((item, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_1__/* .TekoLink */ .A, __spreadProps(__spreadValues({}, item.link), {
      key: index
    }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(HorizontalMenuItem, {
      height: horizontalMenuHeight,
      onMouseEnter: () => {
        setActiveMenu(item);
      }
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Body */ .uT, {
      level: 2,
      line: 1,
      hoverColor: "primary500"
    }, item.name))))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(HorizontalMenuPanel, {
      type,
      className: activeMenu ? "active" : "",
      horizontalMenuHeight,
      menu: activeMenu,
      onClickMenuItem: hideMenuPanel
    }));
  };
  if (type === "vertical")
    return renderVerticalMegaMenu();
  return renderHorizontalMegaMenu();
};
const MegaMenuWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .Z.div`
  position: relative;
`;
const VerticalMenuPanel = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_MenuPanel_es_js__WEBPACK_IMPORTED_MODULE_5__/* .MenuPanel */ .G)(({
  verticalMenuWidth,
  theme
}) => `
  position: absolute;
  top: 0;
  width: calc(75rem - ${verticalMenuWidth});
  left: ${verticalMenuWidth};
  min-height: 100%;
  z-index: 980;
  overflow: hidden;
  transition: all 0.2s;
  visibility: hidden;
  opacity: 0;
  border-radius: ${theme == null ? void 0 : theme.borderRadius.m};
  &.active {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    visibility: visible;
    opacity: 1;
  }
`);
const HorizontalMenuPanel = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_MenuPanel_es_js__WEBPACK_IMPORTED_MODULE_5__/* .MenuPanel */ .G)(({
  horizontalMenuHeight,
  theme
}) => `
  position: absolute;
  left: 0;
  right: 0;
  top: ${horizontalMenuHeight};
  z-index: 980;
  overflow: hidden;
  visibility: hidden;
  opacity: 0;
  transition: all 0.2s;
  border-bottom-right-radius: ${theme == null ? void 0 : theme.borderRadius.m};
  border-bottom-left-radius: ${theme == null ? void 0 : theme.borderRadius.m};
  &.active {
    visibility: visible;
    opacity: 1;
    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.05));
  }
`);
const VerticalMegaMenu = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .Z.div(({ theme, width, height }) => `
  border-radius: ${theme == null ? void 0 : theme.borderRadius.m};
  background-color: ${theme == null ? void 0 : theme.colors.white};
  position: relative;
  overflow: hidden;
  width: ${width};
  height: ${height};
  z-index: 980;
  &.active {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
`);
const HorizontalMegaMenu = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .Z.div(({ theme, height, align }) => `
  height: ${height};
  background-color: ${theme == null ? void 0 : theme.colors.white};
  width: 100%;
  overflow: hidden;
  ${align === "right" ? `display: flex;
        justify-content: flex-end;` : align === "space-between" ? `display: flex;
        justify-content: space-between;` : ""}
`);
const VerticalMenuItem = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .Z.div(({ theme }) => `
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: start;
  gap: ${theme == null ? void 0 : theme.spacing.s8};
  padding: 0 ${theme == null ? void 0 : theme.spacing.s8};
  border-radius: ${theme == null ? void 0 : theme.borderRadius.m};
  overflow: hidden;
  &:hover {
    background-color: ${theme == null ? void 0 : theme.colors.primary50};
    color: ${theme == null ? void 0 : theme.colors.primary500};
  }
`);
const HorizontalMenuItem = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .Z.div(({ theme, height }) => `
  padding: 0 ${theme == null ? void 0 : theme.spacing.s12};
  height: ${height};
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  float: left;
  position: relative;
  transition: all 0.3s ease;
  color: ${theme == null ? void 0 : theme.colors.textPrimary};
  &::after {
    content: '';
    height: 2px;
    background-color: ${theme == null ? void 0 : theme.colors.primary500};
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0;
    transition: all 0.3s ease;
  }
  &:hover {
    color: ${theme == null ? void 0 : theme.colors.primary500};
    &::after {
      opacity: 1;
    }
  }
`);
const VerticalMenuItemImageMegaMenuWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .Z.div`
  width: 22px;
  height: 22px;
`;




/***/ }),

/***/ 74010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ MenuPanel; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71323);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21483);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28247);
/* harmony import */ var _helpers_megaMenu_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41753);
/* harmony import */ var _TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92651);
/* harmony import */ var _EnhancedImage_EnhancedImage_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34567);







var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const MenuPanel = ({
  menu,
  className,
  type,
  onClickMenuItem
}) => {
  var _a, _b, _c, _d;
  const bannerWidth = "14.625rem";
  if (!menu || !((_a = menu.banner) == null ? void 0 : _a.src) && !((_b = menu.children) == null ? void 0 : _b.length))
    return null;
  const bannerSrc = (_c = menu.banner) == null ? void 0 : _c.src;
  const getMenuColumns = () => {
    let totalCols = 6;
    if (type === "vertical")
      totalCols--;
    if (bannerSrc)
      totalCols--;
    return totalCols;
  };
  const newMenu = (0,_helpers_megaMenu_es_js__WEBPACK_IMPORTED_MODULE_1__/* .convertMegaMenu */ .R)(menu, getMenuColumns());
  const col = (item) => {
    return item.map((it, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MenuLv2, {
      key: it.name + `-${index}`,
      onClick: onClickMenuItem
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_2__/* .TekoLink */ .A, __spreadValues({}, it.link), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .SubTitle */ .DK, {
      level: 1,
      line: 1,
      color: "primary500",
      marginBottom: "s8"
    }, it.name)), it.children.map((subItem, index2) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_2__/* .TekoLink */ .A, __spreadProps(__spreadValues({}, subItem.link), {
      key: index2
    }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Text, null, subItem.name)))));
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MenuPanelWrapper, {
    className
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MenuItemsWrapper, __spreadValues({}, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_4__/* .getTrackingData */ .O)({
    regionName: "megaMenuText",
    isTrackContent: true
  })), newMenu.map((menu2, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Column, {
    key: index
  }, col(menu2.column)))), bannerSrc && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_2__/* .TekoLink */ .A, __spreadValues({}, (_d = menu.banner) == null ? void 0 : _d.link), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_EnhancedImage_EnhancedImage_es_js__WEBPACK_IMPORTED_MODULE_5__/* .EnhancedImage */ .N, {
    src: bannerSrc,
    width: bannerWidth,
    height: "100%",
    googleImageParams: {
      width: 400
    },
    tracking: (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_4__/* .getTrackingData */ .O)({
      regionName: "megaMenuBanner",
      isTrackContent: true
    })
  })));
};
const Text = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div */ .Z.div(({ theme }) => `
  color: ${theme == null ? void 0 : theme.colors.textPrimary};
  margin-bottom: 4px;
  &:hover {
    color: ${theme == null ? void 0 : theme.colors.primary500};
  }
`);
const MenuPanelWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div */ .Z.div(({ theme }) => `
  background-color: ${theme == null ? void 0 : theme.colors.white};
  display: flex;
`);
const MenuItemsWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div */ .Z.div(({ theme }) => `
  display: flex;
  flex: 1;
  padding: ${theme == null ? void 0 : theme.spacing.s12};
`);
const MenuLv2 = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div */ .Z.div`
  margin-bottom: 1.5rem;
`;
const Column = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div */ .Z.div`
  width: 25%;
  padding: 0 8px;
`;




/***/ }),

/***/ 92651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ TekoLink; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35874);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21483);
/* harmony import */ var path_to_regexp__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97914);
/* harmony import */ var next_dist_client_route_loader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25726);
/* harmony import */ var next_dist_client_route_loader__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dist_client_route_loader__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_dist_shared_lib_router_utils_route_regex__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1311);
/* harmony import */ var next_dist_shared_lib_router_utils_route_matcher__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94665);








var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const serverless = typeof window !== "undefined";
const normalizeUrl = (url) => {
  if (!serverless || !url || typeof url !== "string")
    return url;
  if (url.match(/^https?:\/\/([^/]+)/)) {
    const urlObj = new URL(url);
    if (urlObj.hostname === window.location.host) {
      return `${urlObj.pathname}${urlObj.search}`;
    }
  }
  return url;
};
const TekoLink = (_a) => {
  var _b = _a, {
    children,
    href,
    as,
    prefetch = false
  } = _b, rest = __objRest(_b, [
    "children",
    "href",
    "as",
    "prefetch"
  ]);
  const [newState, setNewState] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    async function init() {
      if (!href)
        return;
      href = normalizeUrl(href);
      as = normalizeUrl(as);
      if (typeof href === "string") {
        const result = await resolveTekoPathname(getPathname(href));
        if (!result.pathname) {
          result.pathname = href;
        }
        setNewState(__spreadProps(__spreadValues({}, result), { as: as || href }));
      } else {
        const result = await resolveTekoPathname(href);
        if (!result.pathname && (href == null ? void 0 : href.pathname)) {
          result.pathname = href.pathname;
        }
        setNewState(__spreadProps(__spreadValues(__spreadValues({}, href), result), {
          as: as || ((href == null ? void 0 : href.pathname) ? href : null) || void 0
        }));
      }
    }
    init();
  }, [href, as]);
  if (serverless) {
    return newState ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledLink, __spreadValues({
      "data-testid": "TekoLink",
      href: { pathname: newState.pathname, query: newState.query },
      as: newState.as,
      prefetch
    }, rest), children) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children);
  }
  return href ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledLink, __spreadProps(__spreadValues({
    "data-testid": "TekoLink",
    href,
    as
  }, rest), {
    prefetch
  }), children) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children);
};
async function resolveTekoPathname(url) {
  var _a;
  const newHref = { pathname: "", query: {} };
  const pageList = (await (0,next_dist_client_route_loader__WEBPACK_IMPORTED_MODULE_3__.getClientBuildManifest)()).sortedPages;
  for (let i = 0; i < pageList.length; ++i) {
    const normalizedRoute = (_a = /\/(.*)\/(mobile|desktop)(.*)/.exec(pageList[i])) == null ? void 0 : _a[3];
    if (normalizedRoute) {
      const routeRegex = (0,next_dist_shared_lib_router_utils_route_regex__WEBPACK_IMPORTED_MODULE_4__.getRouteRegex)(normalizedRoute);
      const matcher = (0,next_dist_shared_lib_router_utils_route_matcher__WEBPACK_IMPORTED_MODULE_5__.getRouteMatcher)(routeRegex)(url.pathname);
      if (matcher) {
        newHref.pathname = pageList[i];
        newHref.query = __spreadValues(__spreadValues(__spreadValues({}, matcher), getQuerystringObject(url.searchParams)), url.query);
        return newHref;
      }
    }
  }
  for (let i = 0; i < (customizedRoutes == null ? void 0 : customizedRoutes.length); ++i) {
    const { as, href } = customizedRoutes[i];
    const keys = [];
    const regex = (0,path_to_regexp__WEBPACK_IMPORTED_MODULE_6__/* .pathToRegexp */ .Bo)(as, keys);
    if (regex.test(url.pathname)) {
      const params = regex.exec(url.pathname);
      const combinedObject = Object.fromEntries(keys.map((k, i2) => [k.name, params == null ? void 0 : params[i2 + 1]]));
      const filteredObject = {};
      for (const k in combinedObject) {
        if (!/^[0-9]*$/g.test(k.toString())) {
          filteredObject[k] = combinedObject[k];
        }
      }
      const query = filteredObject;
      newHref.pathname = href;
      newHref.query = __spreadValues(__spreadValues(__spreadValues({}, query), getQuerystringObject(url.searchParams)), url.query);
      return newHref;
    }
  }
  return newHref;
}
function getQuerystringObject(qs) {
  const ret = {};
  if (!qs)
    return ret;
  for (const p of qs) {
    ret[p[0]] = p[1];
  }
  return ret;
}
const StyledLink = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((next_link__WEBPACK_IMPORTED_MODULE_1___default()))`
  color: black;
  text-decoration: none;
`;
function getPathname(href) {
  try {
    return new URL(href);
  } catch (e) {
    if (!href.startsWith("/")) {
      href = "/" + href;
    }
    return new URL(`https://fake.com${href}`);
  }
}
const contentSlugs = [
  "chinh-sach-bao-hanh",
  "huong-dan-xem-bao-cao-danh-cho-bo-cong-thuong",
  "chinh-sach-bao-mat",
  "chinh-sach-bao-mat-thanh-toan",
  "chinh-sach-bao-mat-thong-tin",
  "chinh-sach-bao-mat-thong-tin-ca-nhan",
  "chinh-sach-bao-mat-va-chia-se-thong-tin",
  "chinh-sach-bao-mat-va-su-dung",
  "chinh-sach-chiet-khau-uu-dai-mua-sam",
  "chinh-sach-doi-tra",
  "chinh-sach-doi-tra-va-hoan-tien",
  "chinh-sach-giai-quyet-khieu-nai",
  "chinh-sach-giao-hang",
  "chinh-sach-giao-nhan",
  "chinh-sach-kiem-hang",
  "chinh-sach-thanh-toan",
  "chinh-sach-thanh-vien",
  "chinh-sach-the-thanh-vien",
  "chinh-sach-uu-dai",
  "chinh-sach-van-chuyen",
  "chinh-sach-van-chuyen-va-giao-nhan",
  "co-che-dang-tai-thong-tin",
  "danh-sach-cua-hang",
  "dieu-khoan-su-dung",
  "dieu-khoan-va-dieu-kien-giao-dich",
  "gioi-thieu",
  "he-thong-thoi-vang-tich-luy",
  "hinh-thuc-giao-hang",
  "hinh-thuc-thanh-toan",
  "huong-dan-dang-ky-tai-khoan",
  "huong-dan-dat-hang",
  "huong-dan-dat-hang-tren-website",
  "huong-dan-dat-hang-va-dieu-khoan-hop-dong",
  "huong-dan-su-dung",
  "huong-dan-thanh-toan-vnpayqr",
  "quan-ly-chat-luong",
  "quy-che-cung-cap-dich-vu",
  "quy-dinh-va-hinh-thuc-thanh-toan",
  "thong-tin-lien-he",
  "thong-tin-san-pham",
  "thong-tin-ve-dieu-kien-giao-dich"
];
const customizedRoutes = [
  {
    as: "/landing/:id.html",
    href: "/landing/[id]"
  },
  {
    as: "/(.*)-cat.:catId([A-Za-z0-9._-]{1,20})",
    href: "/block-categories/[categoryId]"
  },
  {
    as: "/(.*)-scat.:sellerCategoryId([A-Za-z0-9._-]{1,20})",
    href: "/seller-categories/[sellerCategoryId]"
  },
  {
    as: "/(.*)-sel.:sellerId([A-Za-z0-9._-]{1,20})",
    href: "/sellers/[sellerId]"
  },
  {
    as: "/(.*)-brand.:brandId([A-Za-z0-9._-]{1,20})",
    href: "/brands/[brandId]"
  },
  {
    as: "/(.*)-s:sku([A-Za-z0-9._-]{1,20}).html",
    href: "/products/[sku]"
  },
  {
    as: "/(.*)--s:sku([A-Za-z0-9._-]{1,20})",
    href: "/products/[sku]"
  },
  {
    as: "/(.*)--p:productId([A-Za-z0-9._-]{1,20})",
    href: "/products/detail/[productId]"
  },
  {
    as: "/(.*)-:menuItemId.cat",
    href: "/categories/[menuItemId]"
  },
  {
    as: "/(.*)-c:menuItemId([0-9]{1,})",
    href: "/categories/[menuItemId]"
  },
  {
    as: `/:id(${contentSlugs.join("|")})`,
    href: "/content/[id]"
  }
];




/***/ }),

/***/ 41753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ convertMegaMenu; }
/* harmony export */ });
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const convertMegaMenu = (menu, numberCol) => {
  if (numberCol < 1)
    return [];
  const newArr = menu.children.map((m) => {
    return {
      len: m.children.length + 1,
      column: [__spreadValues({}, m)]
    };
  });
  if (newArr.length <= numberCol)
    return newArr;
  newArr.sort((a, b) => b.len - a.len);
  const result = [...newArr.slice(0, numberCol)];
  let min;
  let k;
  for (let i = numberCol; i < newArr.length; i++) {
    min = result[0].len;
    k = 0;
    for (let j = 0; j < numberCol; j++) {
      if (min > result[j].len) {
        min = result[j].len;
        k = j;
      }
    }
    result[k] = {
      len: result[k].len + newArr[i].len,
      column: [...result[k].column, ...newArr[i].column]
    };
  }
  return result;
};




/***/ }),

/***/ 68481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ NAMESPACE; },
  "K": function() { return /* binding */ lang; },
  "t": function() { return /* binding */ t; }
});

// EXTERNAL MODULE: ../../.yarn/cache/i18next-npm-21.4.0-68c8d0fefd-cd26c166df.zip/node_modules/i18next/dist/esm/i18next.js
var i18next = __webpack_require__(96556);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/lang/vi.es.js
var viLang = {
	"src.components.ProductCard.ProductCard.0": "Sản phẩm này là đồ uống có cồn, quý khách cần xác nhận mình trên 18 tuổi để mua sản phẩm!"
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/lang/en.es.js
var enLang = {
	"Kết thúc sau": "End in",
	"ngày": "day",
	"Còn {{DurationDays}} ngày": "{{DurationDays}} days left",
	"Giảm trực tiếp": "Discount",
	"Tặng": "Receive",
	"GIẢM": "Decrease",
	"Không tìm thấy sản phẩm nào": "No product found",
	"Cảnh báo": "Warning",
	"src.components.ProductCard.ProductCard.0": "This is alcohol product, please confirm you are 18 years old to purchase!",
	"Tôi trên 18 tuổi": "I am over 18",
	"Tôi dưới 18 tuổi": "I am under 18",
	"Xác nhận": "Confirm",
	"TIẾT KIỆM": "Save",
	"Xem thêm": "Expand",
	"Bộ lọc đã dùng": "Used filter",
	"Xóa bộ lọc": "Clear filter",
	"Hàng trưng bày": "Sample",
	"Hàng đặt trước": "Pre-order",
	"Ngừng kinh doanh": "Stop selling",
	"Hàng quà tặng": "Gift",
	"Còn lại {{var0}}": "{{var0}} left",
	"Đã bán {{FlSaleUsedCount}}": "{{FlSaleUsedCount}} sold",
	"Hàng sắp về": "Coming soon",
	"Liên hệ": "Contact",
	"Còn {{stockQuantity}} sản phẩm": "{{stockQuantity}} left",
	"Xem tất cả": "View all",
	"Thương hiệu nổi bật": "Featured brands",
	"Danh mục sản phẩm": "Categories",
	"Sản phẩm dành cho bạn": "Products for you",
	"Chọn ngày nhận hàng": "Select delivery date",
	"Chọn khung giờ": "Select delivery time",
	"Tìm kiếm gần đây": "Recent search",
	"Chọn khu vực nhận hàng": "Select the location",
	"Vui lòng chọn khu vực nhận hàng của bạn": "Please select your location",
	"Tìm kiếm Tỉnh/ Thành phố": "Search Province/City",
	"Không tìm thấy tỉnh thành phố nào !!": "No provice/city is found !!"
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/i18n.es.js




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const NAMESPACE = "teko-ecommerce";
const t = (keys, options) => {
  const text = i18next/* default.t */.Z.t(keys, __spreadProps(__spreadValues({}, options), { ns: NAMESPACE }));
  return text || keys;
};
const lang = {
  vi: viLang,
  en: enLang
};




/***/ }),

/***/ 30752:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ LazyImage; },
/* harmony export */   "x": function() { return /* binding */ WebpImage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86029);



const Wrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div((props) => ({
  maxWidth: "100%",
  position: "relative",
  overflow: "hidden",
  flex: "1 0 auto",
  display: "flex",
  cursor: props.onClick ? "pointer" : "unset",
  zIndex: 0,
  margin: "auto",
  borderRadius: props.borderRadius + "px",
  paddingBottom: props.height ? "" : `${100 / props.aspectRatio}%`,
  border: props.border ? "1px solid #e0e0e0" : "",
  height: props.height ? `${props.height}px !important` : "",
  width: props.width ? `${props.width}px` : "100%",
  backgroundImage: props.thumbnail ? `url("${props.thumbnail}")` : null,
  backgroundSize: props.thumbnail ? "cover" : null,
  contentVisibility: props.height && props.width ? "auto" : null
}));
const WebpImage = ({
  src,
  onClick,
  className,
  height,
  width,
  imageWidth,
  alt = "",
  decoding = "async"
}) => {
  const placeHolder = "data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNjAiIGhlaWdodD0iMjYwIiB2aWV3Qm94PSIwIDAgMjYwIDI2MCI+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxwYXRoIGZpbGw9IiNGNkY2RjYiIGQ9Ik0wIDBoMjYwdjI2MEgweiIvPgogICAgICAgIDxwYXRoIGQ9Ik0xMDQgMTA0aDU0djU0aC01NHoiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjQjRCNEI0IiBkPSJNMTUxLjI1IDEwNi4yNWE0LjUgNC41IDAgMCAxIDQuNSA0LjV2NDAuNWE0LjUgNC41IDAgMCAxLTQuNSA0LjVoLTQwLjVhNC41IDQuNSAwIDAgMS00LjUtNC41di00MC41YTQuNSA0LjUgMCAwIDEgNC41LTQuNWg0MC41em0tMTMuNSAxOGwtOSAxMy41TDEyMiAxMzFsLTYuNzUgMTEuMjVoMzEuNWwtOS0xOHptLTEyLjM3NS02Ljc1YTMuMzc1IDMuMzc1IDAgMSAwIDAgNi43NSAzLjM3NSAzLjM3NSAwIDAgMCAwLTYuNzV6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=";
  let imageUrl = src ? src : placeHolder;
  let altImageUrl = null;
  if (imageUrl && imageUrl.includes("googleusercontent.com")) {
    if (imageWidth || width) {
      imageUrl = `${imageUrl}=w${imageWidth || width}`;
    }
    const checkExt = /=[a-z0-9-]+$/;
    altImageUrl = imageUrl;
    imageUrl = `${imageUrl}${checkExt.test(imageUrl) ? "-rw" : "=rw"}`;
  }
  const imgError = (event) => {
    if (event.target.src !== placeHolder) {
      event.target.src = placeHolder;
    }
    return;
  };
  const imgEle = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    width,
    height,
    onClick,
    className,
    alt,
    onError: imgError,
    src: imageUrl,
    loading: "lazy",
    decoding
  });
  return altImageUrl ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("picture", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", {
    srcSet: imageUrl,
    type: "image/webp"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", {
    srcSet: altImageUrl,
    type: "image/png"
  }), imgEle) : imgEle;
};
const WrapperImage = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(WebpImage)((props) => `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: ${props.contain ? "contain" : props.cover ? "cover" : ""};
  transition: transform 0.5s;
  &:hover {
    transform: ${props.hover === "zoom" ? "scale(1.05)" : ""};
  }
  `);
const LazyImage = ({
  src,
  onClick,
  className,
  contain = false,
  cover = false,
  aspectRatio = 1,
  height,
  width,
  alt = "",
  border = false,
  hover = "",
  borderRadius = 0,
  thumbnail,
  decoding = "async",
  imageWidth
}) => {
  const imgEle = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(WrapperImage, {
    hover,
    className: "lazyload",
    contain,
    imageWidth,
    cover,
    alt,
    "data-src": src,
    src,
    decoding
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    height,
    width,
    border,
    aspectRatio,
    borderRadius,
    onClick,
    className,
    thumbnail
  }, imgEle);
};




/***/ }),

/***/ 84308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ SearchBar; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86029);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28247);
/* harmony import */ var _atoms_Input_Input_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25715);
/* harmony import */ var _atoms_Button_Button_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5510);
/* harmony import */ var _contexts_ThemeProvider_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3414);







var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledSearchBar = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(({ theme, tintColor, barStyle }) => {
  const bgColor = tintColor ? tintColor : theme.colors.gray100;
  const borderRadius = `var(--search-bar-border-radius ,8px)`;
  const styles = {
    display: "flex"
  };
  switch (barStyle) {
    case "nav":
      styles["backgroundColor"] = bgColor;
      styles["borderRadius"] = "8px";
      styles[".search-icon"] = {
        backgroundColor: "transparent",
        order: -1
      };
      styles[".search-input"] = {
        paddingLeft: 0
      };
      break;
    case "light": {
      styles["backgroundColor"] = "#f6f6f6";
      styles["borderRadius"] = "8px";
      styles[".search-icon"] = {
        backgroundColor: "transparent",
        order: -1
      };
      styles[".search-input"] = {
        paddingLeft: 0
      };
      break;
    }
    default:
      styles["backgroundColor"] = bgColor;
      styles.border = `1px solid ${bgColor}`;
      styles.padding = "1px";
      styles["borderRadius"] = borderRadius;
      styles["--button-icon-border-radius"] = borderRadius;
      break;
  }
  return styles;
});
const StyledInput = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_atoms_Input_Input_es_js__WEBPACK_IMPORTED_MODULE_2__/* .Input */ .I)`
  border: 0;
  background-color: transparent;
  flex: 1;
  height: 100%;
`;
const SearchIcon = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_atoms_Button_Button_es_js__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z)`
  height: 36px;
  width: 36px;
  border-radius: 8px;
  padding: 0;
  justify-content: center;
  border: 0;
`;
const SearchIconWrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div`
  display: inline-block;
`;
const SearchBoxWrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div`
  display: inline-block;
  width: 100%;
`;
const SearchBar = (_a) => {
  var _b = _a, {
    placeholder,
    prepend,
    searchIconProps,
    tintColor,
    barStyle,
    className,
    onClickIcon,
    onClickInput
  } = _b, inputProps = __objRest(_b, [
    "placeholder",
    "prepend",
    "searchIconProps",
    "tintColor",
    "barStyle",
    "className",
    "onClickIcon",
    "onClickInput"
  ]);
  const theme = (0,_contexts_ThemeProvider_es_js__WEBPACK_IMPORTED_MODULE_4__/* .useTheme */ .F)();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledSearchBar, {
    tintColor,
    barStyle,
    className
  }, prepend, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SearchBoxWrapper, __spreadValues({}, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_5__/* .getTrackingData */ .O)({
    isTrackContent: true,
    regionName: "headerBar",
    contentName: "searchBox"
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledInput, __spreadValues({
    className: "search-input",
    placeholder,
    onClick: onClickInput,
    role: "searchbox",
    "aria-label": "Search"
  }, inputProps))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SearchIconWrapper, __spreadValues({}, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_5__/* .getTrackingData */ .O)({
    isTrackContent: true,
    regionName: "headerBar",
    contentName: "searchButton"
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SearchIcon, __spreadValues({
    onClick: onClickIcon,
    className: "search-icon",
    variant: "primary",
    "aria-label": "Search",
    icon: { name: "search", size: 26, color: theme.colors.white }
  }, searchIconProps))));
};




/***/ }),

/***/ 10413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ LazyComponent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84443);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91987);



function LazyComponent(param) {
    let { children , timeToRender =0  } = param;
    const ref = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null);
    const { isBot  } = (0,contexts__WEBPACK_IMPORTED_MODULE_2__/* .useGlobalData */ .U5)();
    const { 0: hydrated , 1: setHydrated  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(isBot ? true : false);
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(()=>{
        if (isBot) return;
        const ob = new IntersectionObserver((entries, observer)=>{
            for (const entry of entries){
                if (entry.isIntersecting) {
                    setHydrated(true);
                    observer.disconnect();
                    return;
                }
            }
        });
        ob.observe(ref.current);
        function hydrate(deadline) {
            if (deadline.timeRemaining() > timeToRender) {
                setHydrated(true);
                ob.disconnect();
            } else {
                requestIdleCallback(hydrate);
            }
        }
        if (timeToRender > 0) {
            requestIdleCallback(hydrate);
        }
        return ()=>ob.disconnect();
    }, [
        isBot,
        timeToRender
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: ref,
        className: "lazy-component",
        children: hydrated ? children : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "fake-body",
            style: {
                width: "100%",
                height: 200
            }
        })
    });
}


/***/ }),

/***/ 61035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ PopupRegionPicker; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62411);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81250);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68752);
/* harmony import */ var components_mobile_organisms_DropDownRegionPicker__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(16508);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(21598);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10232);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(21483);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(24122);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84443);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  margin-bottom: 24px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  text-align: center;\n  margin-bottom: 24px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  margin: 32px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  margin-top: 12px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  z-index: 1060;\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}









const PopupRegionPicker = (param)=>{
    let { showPopup , selected , setSelected , terminals , locationOptions , onClosePopup , onSubmitNewLocation , activeLocation , title , useDropdownPicker  } = param;
    const { isBot  } = (0,contexts__WEBPACK_IMPORTED_MODULE_2__/* .useTenantConfig */ .Wx)();
    if (isBot) {
        // disable region picker for bot
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: (terminals === null || terminals === void 0 ? void 0 : terminals.length) > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .Modal */ .u, {
            size: "sm",
            show: showPopup,
            onHide: ()=>onClosePopup(),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui__WEBPACK_IMPORTED_MODULE_4__/* .ModalHeader */ .x, {
                    children: (0,i18n__WEBPACK_IMPORTED_MODULE_5__.t)("Chọn khu vực giao h\xe0ng")
                }),
                !!activeLocation && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CloseIcon, {
                    onClick: ()=>onClosePopup(),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__/* .CloseOutlined */ .X, {
                        size: 32,
                        color: "#000000"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui__WEBPACK_IMPORTED_MODULE_7__/* .ModalBody */ .f, {
                    children: useDropdownPicker ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Wrapper, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                style: {
                                    textAlign: "justify"
                                },
                                children: title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImgWrapper, {
                                src: "https://shopfront-cdn.tekoapis.com/static/umbala/location.svg",
                                alt: "choose location"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_mobile_organisms_DropDownRegionPicker__WEBPACK_IMPORTED_MODULE_8__.DropDownRegionPicker, {
                                terminals: terminals,
                                onSelectTerminal: setSelected
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledButton, {
                                variant: "primary",
                                size: "m",
                                block: true,
                                onClick: ()=>onSubmitNewLocation(),
                                children: (0,i18n__WEBPACK_IMPORTED_MODULE_5__.t)("X\xe1c nhận")
                            })
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledPicker, {
                        options: locationOptions,
                        value: selected,
                        onChange: setSelected,
                        onSubmit: ()=>{
                            onSubmitNewLocation();
                        },
                        title: title
                    })
                })
            ]
        })
    });
};
const StyledPicker = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_10__/* .RegionPicker */ .H)(_templateObject());
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div */ .Z.div(_templateObject1());
const ImgWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* ["default"].img */ .Z.img(_templateObject2());
const StyledButton = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__/* .Button */ .z)(_templateObject3());
const CloseIcon = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div */ .Z.div(_templateObject4());


/***/ }),

/***/ 60862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ NavigationButton; }
/* harmony export */ });
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21483);

const NavigationButton = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .Z.div((param)=>{
    let { theme  } = param;
    return "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n  min-width: 90px;\n  padding: .365rem .75rem;\n  font-size: 13px;\n  position: relative;\n  cursor: pointer;\n  font-weight: 500;\n  color: ".concat(theme.colors.textSecondary, ";\n  a {\n    text-decoration: none;\n    color: unset;\n  }\n  &:hover {\n    color: ").concat(theme.colors.primary500, " !important;\n    > :not(.noti) path {\n      fill: ").concat(theme.colors.primary500, ";\n    }\n    > .noti path{\n      stroke: ").concat(theme.colors.primary500, ";\n    }\n    .title, .text-left .title{\n      color: ").concat(theme.colors.primary500, ";\n    }\n    .text-left {\n      text-align: left;\n    }\n  }\n  ");
});


/***/ }),

/***/ 16508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DropDownRegionPicker": function() { return /* binding */ DropDownRegionPicker; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86029);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61965);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43015);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  margin-bottom: 3px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





const StyledSelect = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .Select */ .P)(_templateObject());
const DropDownRegionPicker = (param)=>{
    let { terminals , onSelectTerminal  } = param;
    const { 0: provinces , 1: setProvinces  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const { 0: districts , 1: setDistricts  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const { 0: wards , 1: setWards  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const { 0: provinceCode , 1: setProvinceCode  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const { 0: districtCode , 1: setDistrictCode  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const { 0: wardCode , 1: setWardCode  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const availCodes = {
        wards: new Set(),
        districts: new Set(),
        provinces: new Set()
    };
    for (const terminal of terminals){
        availCodes.wards.add(terminal.location.ward);
        availCodes.districts.add(terminal.location.district);
        availCodes.provinces.add(terminal.location.province);
    }
    const { locationService  } = (0,contexts__WEBPACK_IMPORTED_MODULE_4__/* .useServices */ .Su)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        // get all provinces;
        locationService.getProvinces().then((allProvinces)=>{
            const allowedProvinces = allProvinces.filter((province)=>availCodes.provinces.has(province.code)).map((province)=>({
                    content: province.name,
                    value: province.code
                }));
            setProvinces(allowedProvinces);
        });
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        // get list of district when province changes
        if (provinceCode) locationService.getDistrictsByProvinceCode(provinceCode).then((allDistricts)=>{
            const allowedDistricts = allDistricts.filter((district)=>availCodes.districts.has(district.code)).map((district)=>({
                    content: district.name,
                    value: district.code
                }));
            setDistricts(allowedDistricts);
            setWards([]);
        });
    }, [
        provinceCode
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        // get list of wards
        if (districtCode) locationService.getWardsByDistrictCode(districtCode).then((allWards)=>{
            const allowedWards = allWards.filter((ward)=>availCodes.wards.has(ward.code)).map((ward)=>({
                    content: ward.name,
                    value: ward.code
                }));
            setWards(allowedWards);
        });
    }, [
        districtCode
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledSelect, {
                title: (0,i18n__WEBPACK_IMPORTED_MODULE_5__.t)("Chọn tỉnh/th\xe0nh phố"),
                selectedValue: provinceCode,
                onChange: (code)=>{
                    if (code !== provinceCode) {
                        setProvinceCode(code);
                        setDistrictCode("");
                        setWardCode("");
                    }
                },
                items: provinces
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledSelect, {
                title: (0,i18n__WEBPACK_IMPORTED_MODULE_5__.t)("Chọn quận/huyện"),
                selectedValue: districtCode,
                onChange: (code)=>{
                    if (code !== districtCode) {
                        setDistrictCode(code);
                        setWardCode("");
                    }
                },
                items: districts
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledSelect, {
                title: (0,i18n__WEBPACK_IMPORTED_MODULE_5__.t)("Chọn phường/x\xe3"),
                selectedValue: wardCode,
                onChange: (code)=>{
                    setWardCode(code);
                    // use index is weird, change later
                    if (onSelectTerminal) onSelectTerminal(terminals.findIndex((terminal)=>terminal.location.ward === code));
                },
                items: wards
            })
        ]
    });
};


/***/ }),

/***/ 45719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ useSearchSuggestions; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84443);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34090);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67438);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46586);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70334);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}





const useSearchSuggestions = function() {
    let { numberOfHistories =5 , limitKeywords  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { isMobile  } = (0,contexts__WEBPACK_IMPORTED_MODULE_2__/* .useGlobalData */ .U5)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const searchHistoryKey = "".concat(isMobile ? "MOBILE" : "DESKTOP", "_SEARCH_HISTORY");
    const initKeyword = router.query.query || "";
    const { onAddSingleItem , onRequestItemSku  } = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useCartV2 */ .T)();
    const { 0: keyword , 1: setKeyword  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initKeyword);
    const { 0: histories , 1: setHistories  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]);
    const { result: suggestions , isSuggestProduct  } = (0,hooks__WEBPACK_IMPORTED_MODULE_4__/* .useKeywords */ .N)(keyword, limitKeywords);
    const getSearchHistory = function() {
        let count = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 5;
        if (typeof localStorage !== "undefined") {
            const historyStorage = localStorage.getItem(searchHistoryKey);
            if (historyStorage) {
                const data = JSON.parse(historyStorage);
                return (data || []).reverse().splice(0, count);
            }
            return [];
        }
        return [];
    };
    const saveSearchHistory = (keyword)=>{
        if (!keyword) return;
        const historyStorage = localStorage.getItem(searchHistoryKey);
        if (!historyStorage) {
            localStorage.setItem(searchHistoryKey, JSON.stringify([
                keyword
            ]));
            return;
        }
        let historyArr = JSON.parse(historyStorage);
        historyArr = historyArr.filter((item)=>JSON.stringify(item) !== JSON.stringify(keyword));
        historyArr = [
            ...historyArr,
            keyword
        ];
        localStorage.setItem(searchHistoryKey, JSON.stringify(historyArr));
        setHistories(getSearchHistory(numberOfHistories));
    };
    const removeSearchHistories = ()=>{
        if (typeof localStorage !== "undefined") {
            localStorage.setItem(searchHistoryKey, JSON.stringify([]));
            setHistories([]);
        }
    };
    const onSearch = (keywordObj)=>{
        saveSearchHistory(keywordObj);
        let targetPath = null;
        if (router.query.query) {
            targetPath = {
                pathname: "/search",
                query: _objectSpread({
                    router: "productListing",
                    query: keywordObj.query
                }, !!keywordObj.categoryId ? {
                    masterCategoryIds: keywordObj.categoryId.toString()
                } : {})
            };
            router.replace(targetPath).then(()=>window.scrollTo(0, 0));
        } else {
            targetPath = {
                pathname: "/search",
                query: _objectSpread({
                    router: "productListing",
                    query: keywordObj.query
                }, !!keywordObj.categoryId ? {
                    masterCategoryIds: keywordObj.categoryId.toString()
                } : {})
            };
            router.push(targetPath).then(()=>window.scrollTo(0, 0));
        }
        const targetUrl = new URL(window.location.origin);
        targetUrl.pathname = targetPath.pathname;
        targetUrl.search = new URLSearchParams(targetPath.query).toString();
        (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_5__/* .trackSearchEvent */ .q)(keywordObj.query);
        (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_6__/* .trackManually */ .gu)("searchButton", "headerBar", "searchProductResult", JSON.stringify({
            searchKeyword: keywordObj.query,
            href: window.location.href,
            url: targetUrl.href
        }));
    };
    const addToCart = async function(product) {
        let quantity = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        if (!!product.sku) {
            await onAddSingleItem({
                sku: product.sku,
                quantity
            }, true);
        } else {
            await onRequestItemSku(product.highlight, quantity);
        }
    };
    const onRedirectDetailProduct = (sku)=>{
        if (sku) {
            router.push("/products/".concat(sku));
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (numberOfHistories > 0) {
            setHistories(getSearchHistory(numberOfHistories));
        } else setHistories([]);
    }, [
        numberOfHistories
    ]);
    return {
        keyword,
        setKeyword,
        histories,
        removeSearchHistories,
        suggestions: suggestions,
        onSearch,
        onRedirectDetailProduct,
        isSuggestProduct,
        addToCart
    };
};


/***/ }),

/***/ 23425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* binding */ useTermsAndPolicies; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(84443);
// EXTERNAL MODULE: ./services/clients/api.ts
var api = __webpack_require__(44844);
;// CONCATENATED MODULE: ./services/cosmic.ts

const accessKey = {
    vnshop: "ulISdNDAN9MMpNCfXhTOSNQdh9tF0xXOL65PdIz6cfw7J319cG",
    karavan: "N0VNt8uGaO0QxlXLEKGcIsKiqGYeuejw0AK4YeYjla0A1qLlVN",
    umbala: "5KihnfendgNLL7k4zZVjBiwE27nYcKcuz6kwxpTXHo8AxYPrRf",
    vinmart: "6OC98OJNAOT9qzq1g6t6UnP72zqOt5tXMurVJ2qELvKovQX70M",
    cpvn: "vXraTMSIWKfTpYZX1YV9LO8XX0Q5pQXLRr9kgGlri635EUlisf",
    takashimaya: "JOUu6Kf1RuuSHfsegx2fkzd13NJSCcrOvxXB6gI6QpYIna4LCv",
    vnpay: "ZvfT9WRG2KZ2dEF8tCRaKgbJZRdqhG0XckUHzkBhHy8XaGHK7K",
    ipp: "YO71gfq1uvrjBaScttrzp4CV6rs5oOfzq4dvrdFACH13wYEHEr",
    soibien: "FjourKXWwl12MoIDd4nj0ZxMwS18G2OUva7wSW6b3iG95Z92x6",
    meatdeli: "TvYF1WNXCIH7bU6dMebRkSyW2dVI3WtZUz2iEogVFjxRtRSuPH",
    apaos: "xn1DNyDK4UtDVvPCYBQNcjD5bWOw0XqE6zF69pOt0tWJPFnEpW",
    "policy-sms": "rNPixiLvJ5s198BVppBXvtyNQVStxByvWFJ2PaRB8qknX79Saw"
};
/*
 * map tenant name to bucket slug name
 * if they are not the same
 * */ const cosmicPath = {
    cp: "cpvn",
    sms: "policy-sms"
};
const getApiKey = (tenant)=>{
    return accessKey[cosmicPath[tenant] || tenant];
};
const cosmicService = {
    getSlugs: async (tenant)=>{
        var ref;
        const readKey = getApiKey(tenant);
        if (!readKey) return [];
        const resp = await api/* cosmicApi.get */.pr.get("/".concat(cosmicPath[tenant] || tenant, "/objects"), {
            params: {
                pretty: true,
                hide_metafields: true,
                props: "slug,title",
                read_key: readKey
            }
        });
        return resp === null || resp === void 0 ? void 0 : (ref = resp.data) === null || ref === void 0 ? void 0 : ref.objects;
    },
    getPost: async (slug, tenant)=>{
        var ref;
        const readKey = getApiKey(tenant);
        if (!readKey) return null;
        const resp = await api/* cosmicApi.get */.pr.get("/".concat(cosmicPath[tenant] || tenant, "/object/").concat(slug), {
            params: {
                hide_metafields: true,
                type: "posts",
                props: "slug,title,content",
                read_key: readKey
            }
        });
        return resp === null || resp === void 0 ? void 0 : (ref = resp.data) === null || ref === void 0 ? void 0 : ref.object;
    }
};
/* harmony default export */ var cosmic = (cosmicService);

// EXTERNAL MODULE: ./helpers/index.ts
var helpers = __webpack_require__(88813);
;// CONCATENATED MODULE: ./hooks/useTermsAndPolicies.ts




const useTermsAndPolicies = ()=>{
    const { 0: termsAndPolicies , 1: setTermsAndPolicies  } = (0,react.useState)([]);
    const { partner , tenant  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const cosmicBucketName = (0,helpers/* isVnpay */.EU)(partner) ? "vnpay" : tenant;
    const getPost = async (slug)=>{
        return await cosmic.getPost(slug, cosmicBucketName);
    };
    (0,react.useEffect)(()=>{
        if (!cosmicBucketName) {
            return;
        }
        cosmic.getSlugs(cosmicBucketName).then((slugs)=>{
            setTermsAndPolicies(slugs);
        });
    }, [
        cosmicBucketName
    ]);
    return {
        getPost,
        termsAndPolicies
    };
};


/***/ }),

/***/ 53525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Layout": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(34655);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-48286aefe3/1/packages/ecommerce/dist/Layout/Footer/Footer.es.js + 1 modules
var Footer_es = __webpack_require__(32777);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-48286aefe3/1/packages/ecommerce/dist/Common/CustomLink/CustomLink.es.js
var CustomLink_es = __webpack_require__(96494);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-48286aefe3/1/packages/ecommerce/dist/Common/Messenger/Messenger.es.js + 2 modules
var Messenger_es = __webpack_require__(21627);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/libs/styled.es.js
var styled_es = __webpack_require__(86029);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/LazyImage/LazyImage.es.js
var LazyImage_es = __webpack_require__(30752);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/molecules/ScrollTopArrow/ScrollTopArrow.es.js
var ScrollTopArrow_es = __webpack_require__(56265);
// EXTERNAL MODULE: ./tenants/_template/desktop/_module/components/NavigationBar.tsx + 9 modules
var NavigationBar = __webpack_require__(88460);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(84443);
// EXTERNAL MODULE: ./hooks/useTermsAndPolicies.ts + 1 modules
var useTermsAndPolicies = __webpack_require__(23425);
// EXTERNAL MODULE: ./components/ForceLogin.tsx
var ForceLogin = __webpack_require__(92926);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/components/Topbar/Topbar.es.js
var Topbar_es = __webpack_require__(738);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/components/Zalo/Zalo.es.js + 2 modules
var Zalo_es = __webpack_require__(66409);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/components/Topbar/TopbarButton.es.js
var TopbarButton_es = __webpack_require__(7934);
;// CONCATENATED MODULE: ./tenants/_template/desktop/_module/_constants.ts
const MEMBERSHIP_POLICY_SLUG_PREFIX = "membership-policy";
const BYPASS_LOGIN_PATHS = /^.*(\/content\/\[id\])|(\/p\/\[slug\])$/g;

// EXTERNAL MODULE: ../../packages/tracking/dist/helper.es.js
var helper_es = __webpack_require__(28247);
// EXTERNAL MODULE: ./components/LazyComponent.tsx
var LazyComponent = __webpack_require__(10413);
// EXTERNAL MODULE: ./hooks/useQuery.tsx
var useQuery = __webpack_require__(46818);
;// CONCATENATED MODULE: ./tenants/_template/desktop/_module/Layout.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  height: 56px;\n  @media print {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}













const TopBannerHeight = styled_es/* styled.div */.z.div(_templateObject());
const DefaultLayout = (param)=>{
    let { children , banners , leftMenu , rightMenu , footerData , footer , navigationBar , forceLogin =false  } = param;
    const LoginWrapper = forceLogin ? ForceLogin/* ForceLogin */.D : react.Fragment;
    const { contactLink , isDisplayMessenger , zaloContactLink , partner , footerDataConfig , noOverride ,  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const topBanner = banners === null || banners === void 0 ? void 0 : banners[0];
    if (!footer && footerData || noOverride) {
        const footerLayout = noOverride ? _objectSpreadProps(_objectSpread({}, footerData), {
            supportAndPolicy: [
                ...footerDataConfig["supportAndPolicy"], 
            ]
        }) : footerData;
        footer = /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_es/* Footer */.$, {
            footer: footerLayout
        });
    }
    const renderContent = ()=>{
        // Render custom pages
        // if (allowRenderCustomPage) {
        //   return <>{children}</>;
        // }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                !partner && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        topBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)(TopBannerHeight, _objectSpreadProps(_objectSpread({}, (0,helper_es/* getTrackingData */.O)({
                            regionName: "topBanner",
                            isTrackContent: true
                        })), {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink_es/* CustomLink */.x, {
                                targetPath: topBanner.targetPath,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage_es/* LazyImage */.w, {
                                    imageWidth: 1920,
                                    height: 56,
                                    cover: true,
                                    src: topBanner.image
                                })
                            })
                        })),
                        (leftMenu || rightMenu) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Topbar_es/* Topbar */.Z, {
                            leftMenu: leftMenu,
                            rightMenu: rightMenu
                        })
                    ]
                }),
                navigationBar,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: children
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyComponent/* LazyComponent */.c, {
                    children: footer
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginWrapper, {
                children: renderContent()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollTopArrow_es/* ScrollTopArrow */.C, {}),
            contactLink && isDisplayMessenger && /*#__PURE__*/ (0,jsx_runtime.jsx)(Messenger_es/* Messenger */.P, {
                url: contactLink
            }),
            zaloContactLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(Zalo_es/* Zalo */.R, {
                url: zaloContactLink
            })
        ]
    });
};
const Layout = (param)=>{
    let { children , banners , leftMenu , rightMenu , footerData , footer , navigationBar , menuItems , liteLogo , forceLogin =false , layoutAreas  } = param;
    const { identityRequired , hasNews  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { termsAndPolicies  } = (0,useTermsAndPolicies/* useTermsAndPolicies */.N)();
    const { 0: requireLogin , 1: setRequireLogin  } = (0,react.useState)(forceLogin);
    const finalRightActions = hasNews ? [
        /*#__PURE__*/ (0,jsx_runtime.jsx)(TopbarButton_es/* TopbarButton */.S, {
            href: "/tin-tuc",
            children: (0,i18n.t)("Tin tức")
        }, 0),
        ...rightMenu, 
    ] : rightMenu;
    const query = (0,useQuery/* useQuery */.aM)({
        ref_code: useQuery/* StringParam */.Zp
    });
    (0,react.useEffect)(()=>{
        if (identityRequired && (query === null || query === void 0 ? void 0 : query.ref_code)) {
            sessionStorage.setItem("ref_code", query.ref_code.toString());
            setRequireLogin(true);
        } else if (!!sessionStorage.getItem("ref_code")) {
            // for case redirected back after login
            setRequireLogin(true);
        }
    }, []);
    if (!footer && footerData) {
        var ref, ref1;
        if (termsAndPolicies.length > 0 && !!((ref = footerData.supportAndPolicy) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.links)) {
            footerData.supportAndPolicy[0].links = termsAndPolicies.filter((param)=>{
                let { slug  } = param;
                return !slug.includes(MEMBERSHIP_POLICY_SLUG_PREFIX);
            }).map((param)=>{
                let { title , slug  } = param;
                return {
                    children: (0,i18n.t)(title),
                    href: "/".concat(slug),
                    target: "_blank"
                };
            });
        }
        footer = /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_es/* Footer */.$, {
            footer: footerData
        });
    }
    if (!navigationBar) {
        navigationBar = /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationBar/* NavigationBar */.v, {
            menuItems: menuItems,
            showShippingFeeMiniCart: false,
            liteLogo: liteLogo
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultLayout, {
        leftMenu: leftMenu,
        rightMenu: finalRightActions,
        navigationBar: navigationBar,
        footer: footer,
        footerData: footerData,
        banners: banners,
        forceLogin: requireLogin,
        layoutAreas: layoutAreas,
        children: children
    });
};


/***/ }),

/***/ 88460:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* binding */ NavigationBar; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(34655);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-dae21f56e7/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(21483);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Container/Container.es.js
var Container_es = __webpack_require__(63512);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/CustomLink/CustomLink.es.js
var CustomLink_es = __webpack_require__(88384);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(71323);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Grid/Row.es.js + 1 modules
var Row_es = __webpack_require__(49624);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Grid/Col.es.js
var Col_es = __webpack_require__(58519);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Divider/Divider.es.js
var Divider_es = __webpack_require__(93005);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-53f627c913/1/packages/ds-icon/dist/components/ChecklistOutlined.es.js
var ChecklistOutlined_es = __webpack_require__(30221);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-53f627c913/1/packages/ds-icon/dist/components/PromoOutlined.es.js
var PromoOutlined_es = __webpack_require__(93692);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-53f627c913/1/packages/ds-icon/dist/components/OrderOutlined.es.js
var OrderOutlined_es = __webpack_require__(26463);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-53f627c913/1/packages/ds-icon/dist/components/LocationOutlined.es.js
var LocationOutlined_es = __webpack_require__(62204);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(84443);
// EXTERNAL MODULE: ./contexts/FeatureFlagProvider.tsx + 1 modules
var FeatureFlagProvider = __webpack_require__(23357);
// EXTERNAL MODULE: ./contexts/LocationProvider.tsx
var LocationProvider = __webpack_require__(58610);
// EXTERNAL MODULE: ./hooks/useLoyalty.ts
var useLoyalty = __webpack_require__(8343);
// EXTERNAL MODULE: ./hooks/useRegionPicker.tsx
var useRegionPicker = __webpack_require__(42816);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/router.js
var next_router = __webpack_require__(35304);
// EXTERNAL MODULE: ./helpers/common.ts
var common = __webpack_require__(4133);
// EXTERNAL MODULE: ./hooks/common.ts
var hooks_common = __webpack_require__(70353);
;// CONCATENATED MODULE: ./hooks/useLiteMode.tsx




const useLiteMode = function(ssrLiteMode) {
    let navOffsetTop = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    const router = (0,next_router.useRouter)();
    const { 0: isLite , 1: setIsLite  } = (0,react.useState)(ssrLiteMode);
    const { 0: dropdownOpen , 1: setDropdownOpen  } = (0,react.useState)(false);
    const listenScrollEvent = ()=>{
        const scrollOffSetTop = window.pageYOffset || document.documentElement.scrollTop;
        if ((0,common/* isHomepage */.GH)(router.asPath)) {
            if (scrollOffSetTop > navOffsetTop) {
                setIsLite(true);
            } else {
                setIsLite(false);
                setDropdownOpen(false);
            }
        } else {
            setIsLite(true);
        }
    };
    (0,react.useEffect)(()=>{
        setDropdownOpen(false);
    }, [
        router.query
    ]);
    (0,react.useEffect)(()=>{
        window.addEventListener("scroll", listenScrollEvent);
        return ()=>{
            window.removeEventListener("scroll", listenScrollEvent);
        };
    }, [
        router.asPath,
        navOffsetTop
    ]);
    (0,hooks_common/* useIsomorphicLayoutEffect */.L)(()=>{
        setIsLite(!(0,common/* isHomepage */.GH)(router.asPath));
    }, [
        router.asPath
    ]);
    const toggle = (0,react.useCallback)(()=>{
        setDropdownOpen(!dropdownOpen);
    }, [
        dropdownOpen
    ]);
    return {
        isLite,
        dropdownOpen,
        toggle
    };
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/molecules/Dropdown/Dropdown.es.js
var Dropdown_es = __webpack_require__(12038);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/molecules/Dropdown/DropdownToggle.es.js
var DropdownToggle_es = __webpack_require__(46207);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/molecules/Dropdown/DropdownMenu.es.js
var DropdownMenu_es = __webpack_require__(70705);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Modal/Modal.es.js + 1 modules
var Modal_es = __webpack_require__(48441);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Modal/ModalHeader.es.js
var ModalHeader_es = __webpack_require__(47873);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Modal/ModalBody.es.js
var ModalBody_es = __webpack_require__(60049);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-48286aefe3/1/packages/ecommerce/dist/Common/ListTile/ListTile.es.js
var ListTile_es = __webpack_require__(74497);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-auth-react-virtual-b1561bfdfb/1/packages/auth-react/dist/context.es.js + 6 modules
var context_es = __webpack_require__(44254);
// EXTERNAL MODULE: ../../packages/tracking/dist/helper.es.js
var helper_es = __webpack_require__(28247);
// EXTERNAL MODULE: ./components/desktop/organisms/style.ts
var style = __webpack_require__(60862);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Button/Button.es.js + 1 modules
var Button_es = __webpack_require__(24122);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-53f627c913/1/packages/ds-icon/dist/components/AccountOutlined.es.js
var AccountOutlined_es = __webpack_require__(71182);
// EXTERNAL MODULE: ./helpers/teko-oauth.ts
var teko_oauth = __webpack_require__(18042);
// EXTERNAL MODULE: ./contexts/ServiceContext.tsx
var ServiceContext = __webpack_require__(43015);
;// CONCATENATED MODULE: ./components/desktop/organisms/UserProfileHeader.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  width: 36px;\n  height: 36px;\n  margin: 5px 0 4px 0;\n  &.vertical-avatar {\n    width: 30px;\n    height: 30px;\n    margin: 3px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  border-radius: 50%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  width: auto;\n  z-index: 9;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  background-color: #fff;\n  border-radius: 4px;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  width: 250px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  padding: 0.5rem;\n  display: flex;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  width: 44px;\n  margin-right: 0.5rem;\n  img {\n    width: 100%;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _taggedTemplateLiteral([
        "\n  .name {\n    font-size: 1rem;\n    margin-bottom: 0;\n  }\n  .extra {\n    font-size: 0.9rem;\n    font-weight: 400;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = _taggedTemplateLiteral([
        "\n  height: 2rem;\n  width: 100%;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = _taggedTemplateLiteral([
        "\n  padding: 10px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = _taggedTemplateLiteral([
        "\n  min-width: 90px;\n  padding: 0.365rem 0.75rem;\n  align-self: stretch;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  :before {\n    content: ' ';\n    width: 30px;\n    height: 30px;\n    border-radius: 15px;\n    background: rgb(236, 236, 236);\n    background: linear-gradient(\n      90deg,\n      rgba(236, 236, 236, 1) 0%,\n      rgba(227, 227, 227, 1) 100%\n    );\n  }\n  .title {\n    width: 60px;\n    height: 8px;\n    margin-top: 9px;\n    border-radius: 4px;\n    background: rgb(236, 236, 236);\n    background: linear-gradient(\n      90deg,\n      rgba(236, 236, 236, 1) 0%,\n      rgba(227, 227, 227, 1) 100%\n    );\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}













const Avatar = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject());
const AvatarImage = emotion_styled_browser_esm/* default.img */.Z.img(_templateObject1());
const StyledDropdown = (0,emotion_styled_browser_esm/* default */.Z)(Dropdown_es/* Dropdown */.L)(_templateObject2());
const DropdownContent = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject3());
const BriefUserPanel = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject4());
const UserAvatar = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject5());
const UserInfo = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject6());
const StyledButton = (0,emotion_styled_browser_esm/* default */.Z)(Button_es/* Button */.z)(_templateObject7());
const ButtonWrapper = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject8());
const SigningButton = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject9());
const ProfileLink = (param)=>{
    let { icon , text , href , regionName , contentName , onClick  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink_es/* CustomLink */.x, {
        href: href,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListTile_es/* ListTile */.x, _objectSpread({
            leading: icon,
            title: text,
            numberOfLine: 2,
            onClick: onClick
        }, (0,helper_es/* getTrackingData */.O)({
            isTrackContent: true,
            regionName,
            contentName
        })))
    });
};
const UserProfileHeader = (param)=>{
    let { vertical =false , customProfile , profileLinks  } = param;
    const { user: userProfile , loading: profileLoading , authService  } = (0,context_es/* useAuth */.a)();
    const { notificationAppId  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { notificationService  } = (0,ServiceContext/* useServices */.Su)();
    const { 0: dropdownOpen , 1: setDropdownOpen  } = (0,react.useState)(false);
    const { 0: showLogoutConfirmModal , 1: setShowLogoutConfirmModal  } = (0,react.useState)(false);
    const toggle = ()=>setDropdownOpen((prevState)=>!prevState);
    const onLogin = ()=>authService.login();
    if (customProfile) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: customProfile
    });
    if (profileLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SigningButton, {
            className: "button",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "title"
            })
        });
    }
    if (!(userProfile === null || userProfile === void 0 ? void 0 : userProfile.userId)) {
        return vertical ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(style/* NavigationButton */.W, _objectSpreadProps(_objectSpread({
            className: "button",
            onClick: onLogin,
            style: {
                flexDirection: "column"
            }
        }, (0,helper_es/* getTrackingData */.O)({
            isTrackContent: true,
            regionName: "headerBar",
            contentName: "loginIcon"
        })), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountOutlined_es/* AccountOutlined */.y, {
                    size: 36,
                    color: "textSecondary"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                    level: 2,
                    weight: "medium",
                    color: "textSecondary",
                    className: "title",
                    children: (0,i18n.t)("Đăng nhập")
                })
            ]
        })) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(style/* NavigationButton */.W, _objectSpreadProps(_objectSpread({
            onClick: onLogin
        }, (0,helper_es/* getTrackingData */.O)({
            isTrackContent: true,
            regionName: "headerBar",
            contentName: "loginIcon"
        })), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountOutlined_es/* AccountOutlined */.y, {
                    size: 36,
                    color: "textSecondary"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "ml-6 text-left",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                            level: 2,
                            weight: "medium",
                            color: "textSecondary",
                            className: "title",
                            children: (0,i18n.t)("Đăng nhập")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                            level: 2,
                            weight: "medium",
                            color: "textSecondary",
                            className: "title",
                            children: (0,i18n.t)("Đăng k\xfd")
                        })
                    ]
                })
            ]
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal_es/* Modal */.u, {
                width: "400px",
                visible: showLogoutConfirmModal,
                onClose: ()=>setShowLogoutConfirmModal(false),
                onCancel: ()=>setShowLogoutConfirmModal(false),
                onOk: ()=>{
                    (0,teko_oauth/* onSignOut */.U3)(authService, notificationService, notificationAppId, window.location.origin);
                },
                cancelText: (0,i18n.t)("Kh\xf4ng"),
                okText: (0,i18n.t)("C\xf3"),
                alignFooter: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalHeader_es/* ModalHeader */.x, {
                        children: (0,i18n.t)("Đăng xuất")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBody_es/* ModalBody */.f, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: (0,i18n.t)("Bạn c\xf3 chắc chắn muốn đăng xuất kh\xf4ng?")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDropdown, _objectSpreadProps(_objectSpread({
                isOpen: dropdownOpen,
                toggle: toggle,
                toggleType: "hover",
                onHide: ()=>setDropdownOpen(false)
            }, (0,helper_es/* getTrackingData */.O)({
                isTrackContent: true,
                regionName: "headerBar",
                contentName: "profileIcon"
            })), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownToggle_es/* DropdownToggle */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(style/* NavigationButton */.W, {
                            className: vertical ? "button" : "",
                            style: vertical ? {
                                flexDirection: "column"
                            } : {
                                flexDirection: "row"
                            },
                            children: [
                                userProfile.avatar ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar, {
                                    className: vertical ? "vertical-avatar" : "",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarImage, {
                                        src: userProfile.avatar,
                                        "aria-label": "Current User Avatar"
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountOutlined_es/* AccountOutlined */.y, {
                                    size: 36,
                                    color: "textSecondary"
                                }),
                                vertical ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                                    level: 2,
                                    weight: "medium",
                                    color: "textSecondary",
                                    className: "title",
                                    children: userProfile.name || userProfile.telephone
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "ml-12 text-left",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                                            level: 2,
                                            weight: "medium",
                                            color: "textSecondary",
                                            className: "title",
                                            children: (0,i18n.t)("Xin ch\xe0o,")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                                            level: 2,
                                            weight: "medium",
                                            color: "textSecondary",
                                            className: "title",
                                            children: userProfile.name || userProfile.telephone
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownMenu_es/* DropdownMenu */.h, {
                        placement: "bottom",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownContent, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BriefUserPanel, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UserAvatar, {
                                            children: userProfile.avatar ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: userProfile.avatar,
                                                alt: "Avatar"
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountOutlined_es/* AccountOutlined */.y, {
                                                size: 36,
                                                color: "textSecondary"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(UserInfo, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    className: "name",
                                                    children: userProfile.name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                    className: "extra",
                                                    children: userProfile.email || userProfile.telephone
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                profileLinks && profileLinks.map((profileLink)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileLink, {
                                        icon: profileLink.icon,
                                        href: profileLink.href,
                                        text: profileLink.text,
                                        contentName: profileLink.contentName,
                                        regionName: profileLink.regionName,
                                        onClick: ()=>setDropdownOpen(false)
                                    }, profileLink.href)),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonWrapper, _objectSpreadProps(_objectSpread({}, (0,helper_es/* getTrackingData */.O)({
                                    isTrackContent: true,
                                    regionName: "headerBar",
                                    contentName: "logOut"
                                })), {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                                        onClick: ()=>{
                                            setDropdownOpen(false);
                                            setShowLogoutConfirmModal(true);
                                        },
                                        variant: "primary",
                                        children: (0,i18n.t)("Đăng xuất")
                                    })
                                }))
                            ]
                        })
                    })
                ]
            }))
        ]
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/dynamic.js
var dynamic = __webpack_require__(85470);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Badge/Badge.es.js
var Badge_es = __webpack_require__(94053);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-53f627c913/1/packages/ds-icon/dist/components/NotificationsOutlined.es.js
var NotificationsOutlined_es = __webpack_require__(41036);
// EXTERNAL MODULE: ./contexts/NotificationProvider.tsx
var NotificationProvider = __webpack_require__(18110);
;// CONCATENATED MODULE: ./components/desktop/organisms/NotificationOverview.tsx
function NotificationOverview_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function NotificationOverview_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            NotificationOverview_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function NotificationOverview_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function NotificationOverview_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        NotificationOverview_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function NotificationOverview_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function NotificationOverview_templateObject() {
    const data = NotificationOverview_taggedTemplateLiteral([
        "\n  width: auto;\n"
    ]);
    NotificationOverview_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NotificationOverview_templateObject1() {
    const data = NotificationOverview_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 10px;\n  left: calc(50% + 12px);\n"
    ]);
    NotificationOverview_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










const MiniNotification = dynamic_default()(()=>__webpack_require__.e(/* import() */ 8600).then(__webpack_require__.bind(__webpack_require__, 18600)).then((mod)=>mod.MiniNotification), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(18600)
            ]
    }
});
const NotificationOverview_StyledDropdown = (0,emotion_styled_browser_esm/* default */.Z)(Dropdown_es/* Dropdown */.L)(NotificationOverview_templateObject());
const WrapperBadge = emotion_styled_browser_esm/* default.div */.Z.div(NotificationOverview_templateObject1());
const NotificationOverview = (param)=>{
    let { title =false  } = param;
    const { 0: openDropdown , 1: setOpenDropdown  } = (0,react.useState)(false);
    const { unRead  } = (0,NotificationProvider/* useNotification */.lm)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NotificationOverview_StyledDropdown, NotificationOverview_objectSpreadProps(NotificationOverview_objectSpread({
        isOpen: openDropdown,
        toggle: ()=>{
            setOpenDropdown((prev)=>!prev);
        },
        toggleType: "hover",
        onHide: ()=>setOpenDropdown(false)
    }, (0,helper_es/* getTrackingData */.O)({
        isTrackContent: true,
        regionName: "headerBar",
        contentName: "notificationItem",
        target: "notification"
    })), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownToggle_es/* DropdownToggle */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(style/* NavigationButton */.W, {
                    className: "button",
                    style: {
                        flexDirection: "column",
                        minWidth: "68px"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationsOutlined_es/* NotificationsOutlined */.Z, {
                            className: "noti",
                            size: 36,
                            color: "textSecondary"
                        }),
                        !!unRead && unRead > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperBadge, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge_es/* Badge */.C, {
                                count: unRead
                            })
                        }),
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                            level: 2,
                            weight: "medium",
                            color: "textSecondary",
                            className: "title",
                            children: (0,i18n.t)("Th\xf4ng b\xe1o")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownMenu_es/* DropdownMenu */.h, {
                popperConfig: {
                    placement: "bottom-end"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniNotification, {
                    onHide: ()=>setOpenDropdown(false)
                })
            })
        ]
    }));
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-48286aefe3/1/packages/ecommerce/dist/Common/Logo/Logo.es.js
var Logo_es = __webpack_require__(47404);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/components/MegaMenu/MegaMenu.es.js
var MegaMenu_es = __webpack_require__(19298);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-53f627c913/1/packages/ds-icon/dist/components/MenuOutlined.es.js
var MenuOutlined_es = __webpack_require__(48673);
;// CONCATENATED MODULE: ./components/desktop/organisms/LogoHeader.tsx
function LogoHeader_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function LogoHeader_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            LogoHeader_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function LogoHeader_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function LogoHeader_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        LogoHeader_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function LogoHeader_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function LogoHeader_templateObject() {
    const data = LogoHeader_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"
    ]);
    LogoHeader_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LogoHeader_templateObject1() {
    const data = LogoHeader_taggedTemplateLiteral([
        "\n  transform: translate(16px, 72px) !important;\n"
    ]);
    LogoHeader_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function LogoHeader_templateObject2() {
    const data = LogoHeader_taggedTemplateLiteral([
        "\n  width: 204px;\n  border-radius: 0.5rem;\n"
    ]);
    LogoHeader_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function LogoHeader_templateObject3() {
    const data = LogoHeader_taggedTemplateLiteral([
        "\n  margin-left: 0.4rem;\n  color: inherit;\n  text-decoration: inherit;\n  :hover {\n    color: inherit;\n  }\n"
    ]);
    LogoHeader_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}











const LogoWrapper = emotion_styled_browser_esm/* default.div */.Z.div(LogoHeader_templateObject());
const StyledLogo = (0,emotion_styled_browser_esm/* default */.Z)(Logo_es/* Logo */.T)((param)=>{
    let { lite  } = param;
    return "\n  ".concat(lite ? "margin-right: 1rem; margin-left: 0.4rem; padding-right: 1rem;" : "", ";\n  -webkit-transition: all .15s ease-in-out;\n  -moz-transition: all .15s ease-in-out;\n  transition: all .15s ease-in-out;\n");
});
const MenuButton = emotion_styled_browser_esm/* default.div */.Z.div((param)=>{
    let { theme  } = param;
    return "\nborder: 1px solid #e0e0e0;\ncursor: pointer;\nborder-radius: 4px;\nline-height: 1rem;\npadding: 0.4rem 0.75rem;\ntext-align: center;\ncolor: ".concat(theme.colors.textSecondary, ";\n&:hover{\n  background: rgb(245, 245, 245);\n}\n");
});
const StyledDropdownMenu = (0,emotion_styled_browser_esm/* default */.Z)(DropdownMenu_es/* DropdownMenu */.h)(LogoHeader_templateObject1());
const MegaMenuWrapper = emotion_styled_browser_esm/* default.div */.Z.div(LogoHeader_templateObject2());
const DummyLink = emotion_styled_browser_esm/* default.a */.Z.a(LogoHeader_templateObject3());
const LogoHeader = (param)=>{
    let { isLite , dropdownOpen , toggle , menuItems  } = param;
    const globalData = (0,GlobalDataContext/* useGlobalData */.U5)();
    const { logo  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LogoWrapper, LogoHeader_objectSpreadProps(LogoHeader_objectSpread({}, (0,helper_es/* getTrackingData */.O)({
        isTrackContent: true,
        regionName: "headerBar",
        contentName: "logoPhongVu",
        target: "homepage"
    })), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink_es/* CustomLink */.x, {
                href: "/",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLogo, {
                    variant: isLite ? "square" : "full",
                    lite: isLite,
                    width: logo[isLite ? "lite" : "full"].width || "auto",
                    height: "".concat(logo[isLite ? "lite" : "full"].height || 35, "px"),
                    alt: globalData.tenant,
                    logoFull: logo.full.path,
                    logoLite: logo.lite.path || logo.full.path
                })
            }),
            isLite && !!(menuItems === null || menuItems === void 0 ? void 0 : menuItems.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown_es/* Dropdown */.L, {
                isOpen: dropdownOpen,
                toggle: toggle,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownToggle_es/* DropdownToggle */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuButton, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuOutlined_es/* MenuOutlined */.y, {
                                    size: 20,
                                    color: "textSecondary"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DummyLink, {
                                    onClick: (evt)=>{
                                        // the purpose of this link
                                        // is to let Google crawler to follow to the categories listing.
                                        // we prevent users from actually clicking here.
                                        evt.preventDefault();
                                        return false;
                                    },
                                    href: "/categories",
                                    children: (0,i18n.t)("Danh mục sản phẩm")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDropdownMenu, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenu_es/* MegaMenu */.V, {
                                menuItems: menuItems,
                                type: "vertical"
                            })
                        })
                    })
                ]
            })
        ]
    }));
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/molecules/SearchBar/SearchBar.es.js
var SearchBar_es = __webpack_require__(84308);
// EXTERNAL MODULE: ./hooks/useSearchSuggestions.tsx
var useSearchSuggestions = __webpack_require__(45719);
// EXTERNAL MODULE: ./contexts/PopularKeywordContext.tsx
var PopularKeywordContext = __webpack_require__(68673);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/libs/styled.es.js
var styled_es = __webpack_require__(86029);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-48286aefe3/1/packages/ecommerce/dist/mobile/Text/Text.es.js
var Text_es = __webpack_require__(47364);
;// CONCATENATED MODULE: ./components/desktop/organisms/RecommendedKeyword.tsx
function RecommendedKeyword_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function RecommendedKeyword_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            RecommendedKeyword_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function RecommendedKeyword_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function RecommendedKeyword_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        RecommendedKeyword_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function RecommendedKeyword_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function RecommendedKeyword_templateObject() {
    const data = RecommendedKeyword_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 4px 0;\n"
    ]);
    RecommendedKeyword_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RecommendedKeyword_templateObject1() {
    const data = RecommendedKeyword_taggedTemplateLiteral([
        "\n  margin: 8px 0 4px;\n"
    ]);
    RecommendedKeyword_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function RecommendedKeyword_templateObject2() {
    const data = RecommendedKeyword_taggedTemplateLiteral([
        "\n  padding-top: 4px;\n  display: flex;\n  flex-wrap: wrap;\n  background: #fff;\n"
    ]);
    RecommendedKeyword_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function RecommendedKeyword_templateObject3() {
    const data = RecommendedKeyword_taggedTemplateLiteral([
        "\n  height: 32px;\n  line-height: 32px;\n  padding: 0 16px;\n  border-radius: 999px;\n  background: #f5f5f5;\n  color: #333;\n  margin: 0 4px 10px 4px;\n  font-size: 14px;\n  cursor: pointer;\n\n  &:hover {\n    background-color: #ececec;\n  }\n"
    ]);
    RecommendedKeyword_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






const StyledSearchTitle = styled_es/* styled.div */.z.div(RecommendedKeyword_templateObject());
const StyledRecommendedKeyword = styled_es/* styled.div */.z.div(RecommendedKeyword_templateObject1());
const RecommendedKeywordWrapper = styled_es/* styled.div */.z.div(RecommendedKeyword_templateObject2());
const RecommendedKeywordItem = styled_es/* styled.div */.z.div(RecommendedKeyword_templateObject3());
const RecommendedKeyword = (param)=>{
    let { popularKeywords , onClick  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRecommendedKeyword, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSearchTitle, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_es/* Text */.x, {
                    fontWeight: "500",
                    textTransform: "uppercase",
                    color: "#82869E",
                    children: (0,i18n.t)("Từ kh\xf3a phổ biến")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendedKeywordWrapper, {
                children: popularKeywords.map((term, index)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendedKeywordItem, RecommendedKeyword_objectSpreadProps(RecommendedKeyword_objectSpread({
                        onClick: ()=>onClick(term)
                    }, (0,helper_es/* getTrackingData */.O)({
                        isTrackContent: true,
                        regionName: "popularKeyword",
                        contentName: term,
                        target: "searchProductResult",
                        payload: JSON.stringify({
                            screenName: "searchProduct",
                            index
                        })
                    })), {
                        children: term
                    }), index);
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/SvgIcon.es.js
var SvgIcon_es = __webpack_require__(49781);
;// CONCATENATED MODULE: ./components/desktop/organisms/SearchRecent.tsx
function SearchRecent_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SearchRecent_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SearchRecent_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function SearchRecent_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function SearchRecent_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        SearchRecent_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function SearchRecent_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SearchRecent_templateObject() {
    const data = SearchRecent_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 4px 0;\n"
    ]);
    SearchRecent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SearchRecent_templateObject1() {
    const data = SearchRecent_taggedTemplateLiteral([
        "\n  min-width: 20px;\n"
    ]);
    SearchRecent_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






const SearchRecent_StyledSearchTitle = styled_es/* styled.div */.z.div(SearchRecent_templateObject());
const StyledSearchItem = styled_es/* styled.div */.z.div((props)=>"\n  display: flex;\n  padding: 0.6rem;\n  cursor: pointer;\n  background: ".concat(props.selected ? "#f5f5f5" : "#fff", ";\n  border-radius: 8px;\n"));
const StyledRemoveHistory = styled_es/* styled.div */.z.div((props)=>"\n  cursor: pointer;\n  color: #848788;\n  &:hover {\n    color: ".concat(props.theme.brand.primary, ";\n  }\n"));
const StyledCategoryName = styled_es/* styled.div */.z.div((props)=>"\n  color: #82869E;\n  font-size: 13px;\n  .cat-name {\n    color: ".concat(props.theme.brand.primary, ";\n  }\n"));
const StyledIcon = (0,styled_es/* styled */.z)(SvgIcon_es/* SvgIcon */.l)(SearchRecent_templateObject1());
const SearchRecent = (param)=>{
    let { histories , onRemoveSearchHistories , onSearch , selected , onHoverItem  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchRecent_StyledSearchTitle, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_es/* Text */.x, {
                        fontWeight: "500",
                        textTransform: "uppercase",
                        color: "#82869E",
                        children: (0,i18n.t)("Lịch sử t\xecm kiếm")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRemoveHistory, SearchRecent_objectSpreadProps(SearchRecent_objectSpread({
                        onClick: onRemoveSearchHistories
                    }, (0,helper_es/* getTrackingData */.O)({
                        isTrackContent: true,
                        regionName: "recentSearch",
                        contentName: "clearHistorySearch",
                        target: "searchProduct"
                    })), {
                        children: (0,i18n.t)("X\xf3a lịch sử")
                    }))
                ]
            }),
            histories === null || histories === void 0 ? void 0 : histories.filter((history)=>!!history).map((history, index)=>{
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(StyledSearchItem, SearchRecent_objectSpreadProps(SearchRecent_objectSpread({
                    onClick: ()=>onSearch(history),
                    selected: index === selected,
                    onMouseEnter: ()=>onHoverItem(index)
                }, (0,helper_es/* getTrackingData */.O)({
                    isTrackContent: true,
                    regionName: "recentSearch",
                    contentName: history === null || history === void 0 ? void 0 : history.query,
                    target: "searchProductResult",
                    payload: JSON.stringify({
                        screenName: "searchProduct",
                        index
                    })
                })), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIcon, {
                            name: "time-outline",
                            size: 20
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                margin: "0 0.6rem"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_es/* Text */.x, {
                                    maxLines: 1,
                                    children: history === null || history === void 0 ? void 0 : history.query
                                }),
                                !!(history === null || history === void 0 ? void 0 : history.categoryId) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCategoryName, {
                                    children: [
                                        "Trong ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "cat-name",
                                            children: history.categoryName
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }), index);
            })
        ]
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Flex/Flex.es.js
var Flex_es = __webpack_require__(36344);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Shape/index.es.js
var Shape_index_es = __webpack_require__(88123);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/LazyImage/LazyImage.es.js
var LazyImage_es = __webpack_require__(13863);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Popover/Tooltip.es.js
var Tooltip_es = __webpack_require__(57572);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Quantity/Quantity.es.js
var Quantity_es = __webpack_require__(38149);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/ButtonIcon/ButtonIcon.es.js
var ButtonIcon_es = __webpack_require__(98640);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-53f627c913/1/packages/ds-icon/dist/components/ShoppingCartOutlined.es.js
var ShoppingCartOutlined_es = __webpack_require__(14214);
;// CONCATENATED MODULE: ./components/desktop/organisms/SearchList.tsx
function SearchList_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SearchList_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SearchList_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function SearchList_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function SearchList_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        SearchList_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function SearchList_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SearchList_templateObject() {
    const data = SearchList_taggedTemplateLiteral([
        "\n  min-width: 20px;\n"
    ]);
    SearchList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SearchList_templateObject1() {
    const data = SearchList_taggedTemplateLiteral([
        "\n  text-overflow: ellipsis;\n"
    ]);
    SearchList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SearchList_templateObject2() {
    const data = SearchList_taggedTemplateLiteral([
        "\n  flex: 1;\n  overflow: hidden;\n"
    ]);
    SearchList_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SearchList_templateObject3() {
    const data = SearchList_taggedTemplateLiteral([
        "\n  min-width: 50px;\n  width: 50px;\n  position: relative;\n"
    ]);
    SearchList_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}








const SearchList_StyledSearchItem = (0,styled_es/* styled */.z)(Flex_es/* Flex */.k)((props)=>"\n  display: flex;\n  padding: 0.6rem;\n  cursor: pointer;\n  border-radius: 8px;\n  align-items: center;\n  justify-content: ".concat(props.isSuggestProduct ? "space-between" : "none", " ;\n  background: ").concat(props.selected ? "#f5f5f5" : "#fff", ";\n  border-bottom: 1px solid #f4f4f4;\n"));
const SearchList_StyledCategoryName = styled_es/* styled.div */.z.div((props)=>"\n  color: #82869E;\n  font-size: 13px;\n  .cat-name {\n    color: ".concat(props.theme.brand.primary, ";\n  }\n"));
const SearchList_StyledIcon = (0,styled_es/* styled */.z)(SvgIcon_es/* SvgIcon */.l)(SearchList_templateObject());
const StyledTextSuggestion = (0,styled_es/* styled */.z)(Text_es/* Text */.x)(SearchList_templateObject1());
const SearchList = (param)=>{
    let { suggestions , onSearch , onHoverItem , selected , onAddToCart , onRedirectDetailProduct , isSuggestProduct =false  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: suggestions.map((s, index)=>{
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(SearchList_StyledSearchItem, SearchList_objectSpreadProps(SearchList_objectSpread({
                onClick: ()=>{
                    return !isSuggestProduct ? onSearch(s) : onRedirectDetailProduct(s === null || s === void 0 ? void 0 : s.sku);
                },
                selected: index === selected,
                onMouseEnter: ()=>onHoverItem(index),
                isSuggestProduct: isSuggestProduct
            }, (0,helper_es/* getTrackingData */.O)({
                isTrackContent: true,
                regionName: "searchSuggestion",
                contentName: s.query,
                target: "searchProductResult",
                payload: JSON.stringify({
                    screenName: "searchProduct",
                    index
                })
            })), {
                children: [
                    isSuggestProduct && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSuggestItem, {
                        product: s,
                        onAddToCart: onAddToCart
                    }),
                    !isSuggestProduct && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchList_StyledIcon, {
                                name: "search",
                                color: "#333",
                                size: 20
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                style: {
                                    margin: "0 0.6rem"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_es/* Text */.x, {
                                        maxLines: 1,
                                        children: s === null || s === void 0 ? void 0 : s.query
                                    }),
                                    !!(s === null || s === void 0 ? void 0 : s.categoryId) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchList_StyledCategoryName, {
                                        children: [
                                            "Trong ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cat-name",
                                                children: s.categoryName
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }), index);
        })
    });
};
const ProductInfoWrapper = (0,styled_es/* styled */.z)(Flex_es/* Flex */.k)(SearchList_templateObject2());
const ProductImageWrapper = (0,styled_es/* styled */.z)(Shape_index_es/* Shape */.b)(SearchList_templateObject3());
/** trust parent is flex */ const ProductSuggestItem = (param)=>{
    let { product , onAddToCart  } = param;
    const { imageUrl , highlight  } = product;
    const { 0: quantity , 1: setQuantity  } = (0,react.useState)(1);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductInfoWrapper, {
                gapX: "s16",
                align: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImageWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage_es/* LazyImage */.w, {
                            aspectRatio: 1,
                            contain: true,
                            src: imageUrl,
                            alt: highlight,
                            borderRadius: 5
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip_es/* Tooltip */.u, {
                        title: highlight,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTextSuggestion, {
                            maxLines: 1,
                            children: highlight
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                gap: "s16",
                align: "center",
                gapX: "s36",
                justify: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Quantity_es/* Quantity */.h, {
                        quantity: quantity,
                        setQuantity: setQuantity,
                        onClick: (e)=>{
                            e.stopPropagation && e.stopPropagation();
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip_es/* Tooltip */.u, {
                        title: (0,i18n.t)("Th\xeam v\xe0o giỏ h\xe0ng"),
                        placement: "bottom",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonIcon_es/* ButtonIcon */.E, {
                            size: 30,
                            color: "primary",
                            onClick: (e)=>{
                                onAddToCart(product, quantity);
                                e.stopPropagation && e.stopPropagation();
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShoppingCartOutlined_es/* ShoppingCartOutlined */.O, {})
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./constants/local.ts
var local = __webpack_require__(79228);
// EXTERNAL MODULE: ../../packages/tracking/dist/cart.es.js
var cart_es = __webpack_require__(46586);
;// CONCATENATED MODULE: ./components/desktop/organisms/SearchBar.tsx
function SearchBar_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SearchBar_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SearchBar_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function SearchBar_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SearchBar_templateObject() {
    const data = SearchBar_taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    SearchBar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SearchBar_templateObject1() {
    const data = SearchBar_taggedTemplateLiteral([
        "\n  border: 1px solid #eaeaea;\n"
    ]);
    SearchBar_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SearchBar_templateObject2() {
    const data = SearchBar_taggedTemplateLiteral([
        "\n  position: absolute;\n  background: #fff;\n  width: 120%;\n  border-radius: 8px;\n  box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.1);\n  padding: 0.5rem 0.8rem;\n  z-index: 1000;\n  display: ",
        ";\n"
    ]);
    SearchBar_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}













const SearchBarWrapper = emotion_styled_browser_esm/* default.div */.Z.div(SearchBar_templateObject());
const StyledSearchBar = (0,emotion_styled_browser_esm/* default */.Z)(SearchBar_es/* SearchBar */.E)(SearchBar_templateObject1());
const SearchSuggestion = emotion_styled_browser_esm/* default.div */.Z.div(SearchBar_templateObject2(), (props)=>props.show ? "block" : "none");
const SearchBar = ()=>{
    const router = (0,next_router.useRouter)();
    const { 0: visible , 1: setVisible  } = (0,react.useState)(false);
    const { 0: selectedSuggestion , 1: setSelectedSuggestion  } = (0,react.useState)(null);
    const { keyword , setKeyword , histories , suggestions , removeSearchHistories , onSearch , isSuggestProduct , onRedirectDetailProduct , addToCart ,  } = (0,useSearchSuggestions/* useSearchSuggestions */.f)();
    const { terms , setStartCallApi  } = (0,PopularKeywordContext/* usePopularKeyword */.y)();
    const { 0: input , 1: setInput  } = (0,react.useState)(keyword || "");
    const showHistories = !(keyword === null || keyword === void 0 ? void 0 : keyword.trim()) && histories.length > 0;
    const showSuggestions = (keyword === null || keyword === void 0 ? void 0 : keyword.trim()) && suggestions.length > 0;
    const showRecommendedKeywords = !(keyword === null || keyword === void 0 ? void 0 : keyword.trim()) && terms.length > 0;
    const handleSearch = (keywordObj)=>{
        onSearch(keywordObj);
        setVisible(false);
    };
    const onKeyUp = (e)=>{
        if (e.keyCode === 13) {
            if (!visible || selectedSuggestion === null) {
                !!(input === null || input === void 0 ? void 0 : input.trim()) && handleSearch({
                    query: input.trim()
                });
                return;
            }
            if (showHistories || showSuggestions && !isSuggestProduct) {
                const searchParam = showHistories ? histories[selectedSuggestion] : suggestions[selectedSuggestion];
                handleSearch(searchParam);
                return;
            }
            if (showSuggestions && isSuggestProduct) {
                var ref;
                onRedirectDetailProduct((ref = suggestions[selectedSuggestion]) === null || ref === void 0 ? void 0 : ref.sku);
                return;
            }
        }
    };
    const handleNavigateSearchResult = (ev)=>{
        if (visible && (ev.keyCode === local/* ARROW_KEY_UP */.rw || ev.keyCode === local/* ARROW_KEY_DOWN */.sf)) {
            ev.preventDefault();
            if (!showSuggestions && !showHistories) return;
            const currentList = showHistories ? histories : suggestions;
            const length = currentList.length;
            if (selectedSuggestion === null) {
                setSelectedSuggestion(0);
                setInput(currentList[0].query);
            } else {
                if (ev.keyCode === local/* ARROW_KEY_UP */.rw) {
                    if (selectedSuggestion <= 0) {
                        setSelectedSuggestion(length - 1);
                        setInput(currentList[length - 1].query);
                    } else {
                        setSelectedSuggestion((prev)=>{
                            setInput(currentList[prev - 1].query);
                            return prev - 1;
                        });
                    }
                } else if (ev.keyCode === local/* ARROW_KEY_DOWN */.sf) {
                    if (selectedSuggestion >= length - 1) {
                        setSelectedSuggestion(0);
                        setInput(currentList[0].query);
                    } else {
                        setSelectedSuggestion((prev)=>{
                            setInput(currentList[prev + 1].query);
                            return prev + 1;
                        });
                    }
                }
            }
        }
    };
    (0,react.useEffect)(()=>{
        var ref, ref1;
        const k = router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : (ref1 = ref.query) === null || ref1 === void 0 ? void 0 : ref1.toString();
        setSelectedSuggestion(null);
        const inputKeyword = k || "";
        setInput(inputKeyword);
        setKeyword(inputKeyword);
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchBarWrapper, {
        onMouseLeave: ()=>setVisible(false),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSearchBar, {
                onChange: (e)=>{
                    if (!visible) setVisible(true);
                    setSelectedSuggestion(null);
                    setInput(e.target.value);
                    setKeyword(e.target.value);
                },
                onKeyUp: onKeyUp,
                onClickInput: ()=>{
                    (0,cart_es/* trackManually */.gu)("searchBox", "headerBar", "searchProduct", JSON.stringify(SearchBar_objectSpread({
                        searchKeyword: input ? input.trim() : ""
                    },  true ? {
                        href: window.location.href,
                        url: window.location.href
                    } : 0)));
                    setVisible(true);
                    setStartCallApi(true);
                },
                value: input,
                placeholder: (0,i18n.t)("Nhập từ kho\xe1 cần t\xecm"),
                onClickIcon: ()=>input && input.trim() && handleSearch({
                        query: input
                    }),
                onKeyDown: handleNavigateSearchResult
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchSuggestion, {
                show: visible && (showHistories || showSuggestions || showRecommendedKeywords),
                children: [
                    showHistories && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchRecent, {
                        selected: selectedSuggestion,
                        histories: histories,
                        onRemoveSearchHistories: removeSearchHistories,
                        onSearch: handleSearch,
                        onHoverItem: setSelectedSuggestion
                    }),
                    showSuggestions && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchList, {
                        suggestions: suggestions,
                        onRedirectDetailProduct: onRedirectDetailProduct,
                        onHoverItem: setSelectedSuggestion,
                        selected: selectedSuggestion,
                        onAddToCart: addToCart,
                        onSearch: handleSearch,
                        isSuggestProduct: isSuggestProduct
                    }),
                    showRecommendedKeywords && /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendedKeyword, {
                        onClick: (k)=>handleSearch({
                                query: k
                            }),
                        popularKeywords: terms
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/desktop/organisms/PopupRegionPicker.tsx
var PopupRegionPicker = __webpack_require__(61035);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/components/Topbar/Topbar.es.js
var Topbar_es = __webpack_require__(738);
// EXTERNAL MODULE: ./helpers/navigation-bar.tsx + 1 modules
var navigation_bar = __webpack_require__(31570);
// EXTERNAL MODULE: ./helpers/index.ts
var helpers = __webpack_require__(88813);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-48286aefe3/1/packages/ecommerce/dist/Cart/CartNumberTracking/CartNumberTracking.es.js
var CartNumberTracking_es = __webpack_require__(21850);
// EXTERNAL MODULE: ./modules/cart/CartContextV2.tsx
var CartContextV2 = __webpack_require__(34090);
;// CONCATENATED MODULE: ./modules/cart/desktop/CartOverview.tsx
function CartOverview_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CartOverview_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CartOverview_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function CartOverview_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function CartOverview_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        CartOverview_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function CartOverview_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CartOverview_templateObject() {
    const data = CartOverview_taggedTemplateLiteral([
        "\n  width: auto;\n"
    ]);
    CartOverview_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CartOverview_templateObject1() {
    const data = CartOverview_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 5px;\n  left: calc(50% + 15px);\n"
    ]);
    CartOverview_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}











const MiniCart = dynamic_default()(()=>__webpack_require__.e(/* import() */ 8557).then(__webpack_require__.bind(__webpack_require__, 68557)).then((mod)=>mod.MiniCart), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(68557)
            ]
    }
});
const CartOverview_StyledDropdown = (0,emotion_styled_browser_esm/* default */.Z)(Dropdown_es/* Dropdown */.L)(CartOverview_templateObject());
const CartOverview_WrapperBadge = emotion_styled_browser_esm/* default.div */.Z.div(CartOverview_templateObject1());
const CartOverview = (param)=>{
    let { vertical =false , showShippingFeeMiniCart =true  } = param;
    const { flattenItems , totalCartItems  } = (0,CartContextV2/* useCartV2 */.T)();
    const { 0: miniCartOpen , 1: setMiniCartOpen  } = (0,react.useState)(false);
    const toggleMiniCart = (0,react.useCallback)(()=>{
        setMiniCartOpen(!miniCartOpen);
    }, [
        miniCartOpen
    ]);
    (0,react.useEffect)(()=>{
        if (true) {
            if (miniCartOpen) {
                document.body.style.overflow = "hidden";
                document.body.style.paddingRight = "".concat(getScrollbarWidth(), "px");
            } else {
                document.body.style.overflow = "unset";
                document.body.style.paddingRight = "unset";
            }
        }
    }, [
        miniCartOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CartOverview_StyledDropdown, CartOverview_objectSpreadProps(CartOverview_objectSpread({
        isOpen: miniCartOpen,
        toggle: toggleMiniCart,
        toggleType: "hover",
        onHide: ()=>setMiniCartOpen(false)
    }, (0,helper_es/* getTrackingData */.O)({
        isTrackContent: true,
        regionName: "headerBar",
        contentName: "cartItem",
        target: "shoppingCart"
    })), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownToggle_es/* DropdownToggle */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink_es/* CustomLink */.x, {
                        href: "/cart",
                        children: vertical ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(style/* NavigationButton */.W, {
                            className: "button",
                            style: {
                                flexDirection: "column"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ShoppingCartOutlined_es/* ShoppingCartOutlined */.O, {
                                    size: 36,
                                    color: "textSecondary"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                                    level: 2,
                                    weight: "medium",
                                    color: "textSecondary",
                                    className: "title",
                                    children: (0,i18n.t)("Giỏ h\xe0ng")
                                }),
                                totalCartItems > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CartOverview_WrapperBadge, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge_es/* Badge */.C, {
                                        count: totalCartItems
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(style/* NavigationButton */.W, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ShoppingCartOutlined_es/* ShoppingCartOutlined */.O, {
                                    size: 36,
                                    color: "textSecondary"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "ml-6 text-left",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                                            level: 2,
                                            weight: "medium",
                                            color: "textSecondary",
                                            className: "title",
                                            children: (0,i18n.t)("Giỏ h\xe0ng của bạn")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                                            level: 2,
                                            weight: "medium",
                                            color: "textSecondary",
                                            className: "title",
                                            children: (0,i18n.t)("({{cartTotalCartItems}}) sản phẩm", {
                                                cartTotalCartItems: flattenItems.length
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CartNumberTracking_es/* CartNumberTracking */.w, {
                        totalItems: totalCartItems
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownMenu_es/* DropdownMenu */.h, {
                popperConfig: {
                    placement: "top-end"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniCart, {
                    onHide: ()=>setMiniCartOpen(false),
                    showShippingFee: showShippingFeeMiniCart
                })
            })
        ]
    }));
};
const getScrollbarWidth = ()=>{
    let width = 0;
    if ( true && document.body.scrollHeight > window.innerHeight) {
        if (window.scrollbarWidth) {
            return window.scrollbarWidth;
        }
        const outer = document.createElement("div");
        outer.style.visibility = "hidden";
        outer.style.overflow = "scroll";
        document.body.appendChild(outer);
        const inner = document.createElement("div");
        outer.appendChild(inner);
        width = outer.offsetWidth - inner.offsetWidth;
        outer.parentNode.removeChild(outer);
        window.scrollbarWidth = width;
    }
    return width;
};

// EXTERNAL MODULE: ../../packages/utils/dist/polyfill.es.js
var polyfill_es = __webpack_require__(93859);
// EXTERNAL MODULE: ./components/RegionPickerSuggestionPopover/RegionPickerSuggestionPopover.tsx
var RegionPickerSuggestionPopover = __webpack_require__(96199);
;// CONCATENATED MODULE: ./tenants/_template/desktop/_module/components/NavigationBar.tsx
function NavigationBar_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function NavigationBar_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            NavigationBar_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function NavigationBar_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function NavigationBar_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        NavigationBar_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function NavigationBar_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function NavigationBar_templateObject() {
    const data = NavigationBar_taggedTemplateLiteral([
        "\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 550;\n  background: rgba(0, 0, 0, 0.5);\n  -webkit-transition-delay: 0.1s;\n  transition-delay: 0.1s;\n"
    ]);
    NavigationBar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NavigationBar_templateObject1() {
    const data = NavigationBar_taggedTemplateLiteral([
        "\n  min-width: fit-content;\n"
    ]);
    NavigationBar_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


















const StyledNavigationBar = emotion_styled_browser_esm/* default.div */.Z.div((param)=>{
    let { lite , verticalNavItem  } = param;
    return "\n  @media print {\n    display: none;\n  }\n  background-color: #fff;\n  position: sticky;\n  top: 0;\n  z-index: 1040;\n  box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.1);\n  @media screen and (max-width: 767px) {\n    height: auto !important;\n  }\n\n  ".concat(lite && verticalNavItem ? "\n      min-width: 68px;\n      .title {\n        visibility: hidden;\n        height: 0;\n      }\n      .button {\n        gap: 0;\n      }\n    " : "", "\n");
});
const NavItem = emotion_styled_browser_esm/* default.div */.Z.div((param)=>{
    let { theme  } = param;
    return "\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 0.5rem;\n  cursor: pointer;\n  &:hover {\n    div {\n      color: ".concat(theme.colors.primary500, " !important;\n    }\n    path {\n      fill: ").concat(theme.colors.primary500, " !important;\n    }\n  }\n");
});
const Overlay = emotion_styled_browser_esm/* default.div */.Z.div(NavigationBar_templateObject());
const StyledContainer = (0,emotion_styled_browser_esm/* default */.Z)(Container_es/* Container */.W)(NavigationBar_templateObject1());
const isVerticalNavItem = (tenant)=>{
    switch(tenant){
        // case 'phongvu':
        //   return true;
        case "ipp":
            return true;
        default:
            return false;
    }
};
const defaultDisplayConfig = {
    order: false,
    promotion: false,
    login: true,
    cart: true,
    additional: undefined
};
const NavigationBar = (param)=>{
    let { showShippingFeeMiniCart =true , menuItems , liteLogo , displayConfig  } = param;
    displayConfig = NavigationBar_objectSpread({}, defaultDisplayConfig, displayConfig);
    const { partner , tenant , megaMenuType ="vertical" , alignMegaMenu ="left" , notificationAppId ,  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { user , authService  } = (0,context_es/* useAuth */.a)();
    const { loyaltyMemberInfo  } = (0,useLoyalty/* useLoyalty */.m)();
    const profileLinks = (0,react.useMemo)(()=>{
        return (0,navigation_bar/* getNavItems */.r)({
            tenant,
            logged: !!(user === null || user === void 0 ? void 0 : user.userId),
            isLoyaltyMember: !!loyaltyMemberInfo,
            showNotificationItem: !!notificationAppId
        });
    }, [
        tenant,
        user
    ]);
    const { flags  } = (0,FeatureFlagProvider/* useFeatureFlags */.g)();
    const regionPickerProps = (0,useRegionPicker/* useRegionPicker */.j)();
    const region = regionPickerProps === null || regionPickerProps === void 0 ? void 0 : regionPickerProps.activeLocation;
    const { setShowed: showLocationPopup , selectedLocation , showRegionPickerSuggestionPopover , onCloseRegionPickerSuggestionPopover , enabled: locationPickerEnabled ,  } = (0,LocationProvider/* useLocation */.T)();
    const onLogin = ()=>authService.login(window.location.href);
    const router = (0,next_router.useRouter)();
    const { 0: navOffsetTop , 1: setNavOffsetTop  } = (0,react.useState)(0);
    const { isLite , dropdownOpen , toggle  } = useLiteMode(liteLogo, navOffsetTop);
    const LoginIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)(UserProfileHeader, {
        vertical: isVerticalNavItem(tenant),
        customProfile: !!partner ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink_es/* CustomLink */.x, {
            href: "/account/orders",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(style/* NavigationButton */.W, {
                className: "button",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChecklistOutlined_es/* ChecklistOutlined */.H, {
                        size: 36,
                        color: "textSecondary"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: (0,i18n.t)("Quản l\xfd đơn h\xe0ng")
                    })
                ]
            })
        }) : undefined,
        profileLinks: profileLinks
    });
    const PromotionIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink_es/* CustomLink */.x, {
        href: "/khuyen-mai",
        target: "_blank",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(style/* NavigationButton */.W, NavigationBar_objectSpreadProps(NavigationBar_objectSpread({
            className: "button",
            style: isVerticalNavItem(tenant) ? {
                flexDirection: "column"
            } : {
                flexDirection: "row"
            }
        }, (0,helper_es/* getTrackingData */.O)({
            isTrackContent: true,
            regionName: "headerBar",
            contentName: "promotionLandingIcon"
        })), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoOutlined_es/* PromoOutlined */.G, {
                    size: 36,
                    color: "textSecondary"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "title",
                    children: (0,i18n.t)("Khuyến m\xe3i")
                })
            ]
        }))
    });
    const OrderIcon = /*#__PURE__*/ (0,jsx_runtime.jsxs)(style/* NavigationButton */.W, NavigationBar_objectSpreadProps(NavigationBar_objectSpread({
        className: "button",
        onClick: ()=>{
            if (!(user === null || user === void 0 ? void 0 : user.userId)) {
                onLogin();
            } else {
                router.push("/account/orders");
            }
        },
        style: isVerticalNavItem(tenant) ? {
            flexDirection: "column"
        } : {
            flexDirection: "row"
        }
    }, (0,helper_es/* getTrackingData */.O)({
        isTrackContent: true,
        regionName: "headerBar",
        contentName: "orderIcon"
    })), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderOutlined_es/* OrderOutlined */.y, {
                size: 36,
                color: "textSecondary"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "title",
                children: (0,i18n.t)("Đơn h\xe0ng")
            })
        ]
    }));
    const NotificationIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationOverview, {
        title: isVerticalNavItem(tenant)
    });
    const CartIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)(CartOverview, {
        showShippingFeeMiniCart: showShippingFeeMiniCart,
        vertical: isVerticalNavItem(tenant)
    });
    const RegionPickerIcon = (param)=>{
        let { locationName  } = param;
        const showRegionPickerModal = ()=>{
            if (flags.epic_ecom_284) {
                showLocationPopup(true);
            } else {
                regionPickerProps.onOpenPopup();
            }
        };
        // Don't show this icon on the server side
        if (!(0,helpers/* isServerless */.ep)()) {
            return null;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionPickerSuggestionPopover/* RegionPickerSuggestionPopover */.R, {
            active: showRegionPickerSuggestionPopover,
            onClose: onCloseRegionPickerSuggestionPopover,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavItem, NavigationBar_objectSpreadProps(NavigationBar_objectSpread({
                onClick: showRegionPickerModal
            }, (0,helper_es/* getTrackingData */.O)({
                isTrackContent: true,
                regionName: "headerBar",
                contentName: "location"
            })), {
                className: "att-home-page-delivery-area",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationOutlined_es/* LocationOutlined */.f, {
                        size: 36,
                        color: "textSecondary"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                        level: 2,
                        weight: "medium",
                        color: "textSecondary",
                        children: locationName
                    })
                ]
            }))
        });
    };
    const getNavMenuByDisplayConfig = ()=>{
        var ref;
        const { order , promotion , login , cart , additional  } = displayConfig;
        const navMenu = [];
        if (promotion) navMenu.push(PromotionIcon);
        if (order) navMenu.push(OrderIcon);
        if (login) navMenu.push(LoginIcon);
        if (notificationAppId) navMenu.push(NotificationIcon);
        if (cart) navMenu.push(CartIcon);
        if (locationPickerEnabled) {
            navMenu.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(RegionPickerIcon, {
                locationName: selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.locationName
            }));
        } else if (region && (regionPickerProps === null || regionPickerProps === void 0 ? void 0 : (ref = regionPickerProps.terminals) === null || ref === void 0 ? void 0 : ref.length) > 1) {
            navMenu.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(RegionPickerIcon, {
                locationName: region === null || region === void 0 ? void 0 : region.label
            }));
        }
        if (additional) navMenu.push(additional);
        return navMenu;
    };
    const { 0: navItems , 1: setNavItems  } = (0,react.useState)(getNavMenuByDisplayConfig());
    (0,react.useEffect)(()=>{
        setNavItems(getNavMenuByDisplayConfig());
    }, [
        user === null || user === void 0 ? void 0 : user.userId,
        selectedLocation
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            dropdownOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledNavigationBar, {
                lite: isLite,
                verticalNavItem: isVerticalNavItem(tenant),
                id: "mainNavigationBar",
                ref: (navRef)=>{
                    (0,polyfill_es/* requestIdleCallback */.Kk)((deadline)=>{
                        if (navRef && deadline.timeRemaining() > 0) {
                            const { scrollTop  } = document.documentElement;
                            setNavOffsetTop(scrollTop % Topbar_es/* TOPBAR_HEIGHT */.n);
                        }
                    });
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container_es/* Container */.W, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                            gutter: [
                                16,
                                16
                            ],
                            align: "middle",
                            style: megaMenuType === "vertical" && isVerticalNavItem(tenant) && isLite ? {
                                height: "72px"
                            } : {
                                height: "88px"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoHeader, {
                                        isLite: megaMenuType === "vertical" && ( true ? isLite : 0),
                                        dropdownOpen: dropdownOpen,
                                        toggle: toggle,
                                        // Only show mega menu dropdown on type vertical
                                        menuItems: megaMenuType === "vertical" ? menuItems : []
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                                    flex: "auto",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBar, {})
                                }),
                                navItems.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                                        children: item
                                    }, index))
                            ]
                        })
                    }),
                    megaMenuType === "horizontal" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_es/* Divider */.i, {
                                gap: 0,
                                color: "divider"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContainer, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_es/* Row */.X, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                                        span: 12,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenu_es/* MegaMenu */.V, {
                                            type: "horizontal",
                                            align: alignMegaMenu,
                                            menuItems: menuItems
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            !flags.epic_ecom_284 && /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupRegionPicker/* PopupRegionPicker */.H, NavigationBar_objectSpread({}, regionPickerProps))
        ]
    });
};


/***/ }),

/***/ 46586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CL": function() { return /* binding */ trackRemoveFromCart; },
/* harmony export */   "Kc": function() { return /* binding */ trackAddToCart; },
/* harmony export */   "_g": function() { return /* binding */ trackChangeQuantityProduct; },
/* harmony export */   "bz": function() { return /* binding */ trackSelectProduct; },
/* harmony export */   "gu": function() { return /* binding */ trackManually; },
/* harmony export */   "ih": function() { return /* binding */ trackDecreaseQuantityProduct; },
/* harmony export */   "lM": function() { return /* binding */ trackIncreaseQuantityProduct; },
/* harmony export */   "wr": function() { return /* binding */ trackAddToCartManually; }
/* harmony export */ });
/* harmony import */ var _interface_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41873);


const trackAddToCart = (product, selectedPromotionId, type, status, cartId) => {
  var _a;
  const { defaultPromotions = [] } = product;
  window.track(type ? type : _interface_es_js__WEBPACK_IMPORTED_MODULE_0__/* .AddToCartType.ADDTOCART */ .h.ADDTOCART, {
    cartId,
    skuId: product.productInfo.sku,
    skuName: product.productInfo.name,
    promotionId: `${[
      ...defaultPromotions.map((promo) => promo.id),
      selectedPromotionId || ""
    ].join(",")}`,
    status: status || "success",
    quantity: 1,
    price: parseInt(product.prices[0].supplierRetailPrice),
    promotionPrice: product.addToCartPrice
  });
  (_a = window.dataLayer) == null ? void 0 : _a.push({
    event: _interface_es_js__WEBPACK_IMPORTED_MODULE_0__/* .AddToCartType.ADDTOCART */ .h.ADDTOCART,
    ecommerce: {
      currencyCode: "VND",
      add: {
        products: [
          {
            name: product.productInfo.name,
            id: product.productInfo.sku,
            price: product.addToCartPrice,
            quantity: 1,
            category: ""
          }
        ]
      }
    }
  });
};
const trackIncreaseQuantityProduct = (item, diff = 1, cartId) => {
  var _a;
  window.track("increaseQuantityProduct", {
    cartId,
    skuId: item.sku,
    skuName: item.name,
    status: "success",
    quantity: item.quantity + diff,
    price: item.sellPrice,
    promotionPrice: item.price
  });
  (_a = window.dataLayer) == null ? void 0 : _a.push({
    event: _interface_es_js__WEBPACK_IMPORTED_MODULE_0__/* .AddToCartType.ADDTOCART */ .h.ADDTOCART,
    ecommerce: {
      currencyCode: "VND",
      add: {
        products: [
          {
            name: item.name,
            id: item.sku,
            price: item.price,
            quantity: diff,
            category: ""
          }
        ]
      }
    }
  });
};
const trackDecreaseQuantityProduct = (item, diff = 1, cartId) => {
  window.track("decreaseQuantityProduct", {
    cartId,
    skuId: item.sku,
    skuName: item.name,
    status: "success",
    quantity: item.quantity - diff,
    price: item.sellPrice,
    promotionPrice: item.price
  });
};
const trackChangeQuantityProduct = (item, newQty, cartId) => {
  const currQty = item.quantity;
  if (currQty < newQty) {
    trackIncreaseQuantityProduct(item, newQty - currQty, cartId);
  } else if (currQty > newQty) {
    trackDecreaseQuantityProduct(item, currQty - newQty, cartId);
  }
};
const trackRemoveFromCart = (item, cartId) => {
  var _a;
  window.track("removeFromCart", {
    cartId,
    skuId: item.sku,
    skuName: item.name,
    status: "success",
    quantity: item.quantity,
    price: item.sellPrice,
    promotionPrice: item.price
  });
  (_a = window.dataLayer) == null ? void 0 : _a.push({
    event: "removeFromCart",
    ecommerce: {
      remove: {
        products: [
          {
            name: item.name,
            id: item.sku,
            price: item.price,
            quantity: item.quantity,
            category: ""
          }
        ]
      }
    }
  });
};
const trackManually = (contentName, regionName, target, payload) => {
  window.track("manualTrackInteractionContent", {
    interaction: "click",
    contentName,
    regionName,
    target,
    payload
  });
};
const trackAddToCartManually = (trackingScreenName, sku) => {
  return trackManually("addToCart", "productCard", trackingScreenName, JSON.stringify({
    sku,
    screenName: trackingScreenName,
    index: 0
  }));
};
const trackSelectProduct = (item, checked, cartId) => {
  window.track(checked ? "selectProduct" : "unselectProduct", {
    cartId,
    skuId: item.sku,
    skuName: item.name,
    price: item.sellPrice,
    promotionPrice: item.price,
    quantity: item.quantity,
    status: "success"
  });
};




/***/ }),

/***/ 41873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ AddToCartType; }
/* harmony export */ });
var AddToCartType = /* @__PURE__ */ ((AddToCartType2) => {
  AddToCartType2["ADDTOCART"] = "addToCart";
  AddToCartType2["BUYNOW"] = "buyNow";
  return AddToCartType2;
})(AddToCartType || {});




/***/ }),

/***/ 67438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ trackSearchEvent; }
/* harmony export */ });
const trackSearchEvent = (keyword) => {
  var _a;
  window.track("siteSearch", {
    params: "{}",
    keywords: keyword
  });
  (_a = window.dataLayer) == null ? void 0 : _a.push({
    event: "view_search_results",
    content_keyword: keyword
  });
};




/***/ }),

/***/ 84019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v2": function() { return /* reexport */ Alignment; },
  "hT": function() { return /* reexport */ DSSize; },
  "fd": function() { return /* reexport */ DividerStyleEnum; }
});

// UNUSED EXPORTS: DividerTypeEnum, Variant, VerticalAlignment

;// CONCATENATED MODULE: ../../packages/types/dist/shared/enum.es.js
var Variant = /* @__PURE__ */ ((Variant2) => {
  Variant2["primary"] = "primary";
  Variant2["secondary"] = "secondary";
  Variant2["ghost"] = "ghost";
  Variant2["link"] = "link";
  return Variant2;
})(Variant || {});
var Alignment = /* @__PURE__ */ ((Alignment2) => {
  Alignment2["left"] = "left";
  Alignment2["center"] = "center";
  Alignment2["right"] = "right";
  Alignment2["justify"] = "justify";
  return Alignment2;
})(Alignment || {});
var VerticalAlignment = /* @__PURE__ */ ((VerticalAlignment2) => {
  VerticalAlignment2["top"] = "top";
  VerticalAlignment2["center"] = "center";
  VerticalAlignment2["bottom"] = "bottom";
  return VerticalAlignment2;
})(VerticalAlignment || {});
var DSSize = /* @__PURE__ */ ((DSSize2) => {
  DSSize2["small"] = "small";
  DSSize2["medium"] = "medium";
  DSSize2["default"] = "default";
  DSSize2["large"] = "large";
  return DSSize2;
})(DSSize || {});
var DividerTypeEnum = /* @__PURE__ */ ((DividerTypeEnum2) => {
  DividerTypeEnum2["text"] = "text";
  DividerTypeEnum2["icon"] = "icon";
  return DividerTypeEnum2;
})(DividerTypeEnum || {});
var DividerStyleEnum = /* @__PURE__ */ ((DividerStyleEnum2) => {
  DividerStyleEnum2["solid"] = "solid";
  DividerStyleEnum2["double"] = "double";
  DividerStyleEnum2["dotted"] = "dotted";
  DividerStyleEnum2["dashed"] = "dashed";
  return DividerStyleEnum2;
})(DividerStyleEnum || {});



;// CONCATENATED MODULE: ../../packages/types/dist/shared/index.es.js



/***/ }),

/***/ 93859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D_": function() { return /* binding */ scheduleTaskInIdleTime; },
/* harmony export */   "GK": function() { return /* binding */ cancelIdleCallback; },
/* harmony export */   "Kk": function() { return /* binding */ requestIdleCallback; }
/* harmony export */ });
function requestIdleCallback(callback, options) {
  if (typeof window !== "undefined") {
    if ("requestIdleCallback" in window) {
      return window.requestIdleCallback(callback, options);
    } else {
      return _requestIdleCallback(callback);
    }
  } else {
    return _requestIdleCallback(callback);
  }
}
function cancelIdleCallback(id) {
  if (typeof window !== "undefined") {
    if ("cancelIdleCallback" in window) {
      window.cancelIdleCallback(id);
    } else {
      _cancelIdleCallback(id);
    }
  }
}
function _requestIdleCallback(cb) {
  const start = Date.now();
  return setTimeout(function() {
    cb({
      didTimeout: false,
      timeRemaining: function() {
        return Math.max(0, 50 - (Date.now() - start));
      }
    });
  }, 1);
}
function _cancelIdleCallback(id) {
  clearTimeout(id);
}
function scheduleTaskInIdleTime(cb, timeout, minTimeForProcessing = 0) {
  const deadline = Date.now() + timeout;
  const schedule = (timeout2) => requestIdleCallback((idleData) => {
    const now = Date.now();
    if (now >= deadline || idleData.timeRemaining() > minTimeForProcessing)
      return cb();
    schedule(deadline - now);
  }, { timeout: timeout2 });
  schedule(timeout);
}




/***/ })

}]);